import React, { useState, useEffect } from 'react';
import Crud from '../components/crud';
import View from '../components/view';
import utils from '../components/utils';

function MeusDadosRepresamentoAlteracao() {
  const [usuario, setUsuario] = useState({ changed: { eager: true }, selected: {} });
  const [data, setData] = useState({ changed: { eager: true }, selected: {} });
  const [eventos, setEventos] = useState([]);

  let [ready, setReady] = useState(false);
  let [crud, setCrud] = useState({});

  const user = utils.getUser();
  const id = user.id;

  const editEndereco = {
    id: 'edit',
    space: 12,
    elements: {
      form: {
        id: 'form',
        layout: 'form',
        type: 'form',
        space: 12,
        elements: {
          tabs: {
            index: 0,
            id: 'tabs',
            layout: 'tab',
            type: 'tab',
            rendered: '#{}',
            visible: false,
            elements: {
              tab_group_dados: {
                index: 0,
                id: 'tab_group_dados',
                layout: 'item',
                target: 'group_dados',
                type: 'item',
                label: utils.lng('dados','Dados'),
                click: {
                  action: 'setTab',
                },
              },
            },
          },
          group_dados: {
            index: 0,
            name: 'group_dados',
            type: 'card',
            space: 12,
            label: utils.lng('dados_cadastrais','Dados cadastrais'),
            elements: {
              cep: {
                edit: true,
                id: 'cep',
                entity: 'String',
                name: 'cep',
                group: 'group_dados',
                field: 'cep',
                mask: '99.999-999',
                type: 'text',
                space: 6,
                min: 8,

                required: true,
                rowEdit: false,
                title: utils.lng('cep','CEP'),
                label: utils.lng('cep','CEP'),
                attrs: {
                  change: {
                    url: 'consultarCEP',
                    send: {
                      cep: 'cep',
                    },
                  },
                  owner: '',
                },
              },
              bairro: {
                edit: true,
                id: 'bairro',
                entity: 'String',
                name: 'bairro',
                group: 'group_dados',
                field: 'bairro',
                type: 'text',
                space: 6,
                max: 50,
                size: 50,

                rowEdit: false,
                title: utils.lng('bairro','Bairro'),
                label: utils.lng('bairro','Bairro'),
                attrs: {
                  required: "${utils.getUser().codigo_pais != 'USA'}",
                  owner: '',
                },
              },
              complemento: {
                edit: true,
                id: 'complemento',
                entity: 'String',
                name: 'complemento',
                group: 'group_dados',
                field: 'complemento',
                type: 'text',
                space: 6,

                rowEdit: false,
                title: utils.lng('complemento','Complemento'),
                label: utils.lng('complemento','Complemento'),
                attrs: {
                  owner: '',
                },
              },
              logradouro: {
                edit: true,
                id: 'logradouro',
                entity: 'String',
                name: 'logradouro',
                group: 'group_dados',
                field: 'logradouro',
                type: 'text',
                space: 6,

                rowEdit: false,
                title: utils.lng('logradouro','Logradouro'),
                label: utils.lng('logradouro','Logradouro'),
                attrs: {
                  required: "${utils.getUser().codigo_pais != 'USA'}",
                  owner: '',
                },
              },
              numero: {
                edit: true,
                id: 'numero',
                entity: 'String',
                name: 'numero',
                group: 'group_dados',
                field: 'numero',
                type: 'text',
                space: 6,
                max: 5,

                rowEdit: false,
                title: utils.lng('numero','Numero'),
                label: utils.lng('numero','Numero'),
                attrs: {
                  required: "${utils.getUser().codigo_pais != 'USA'}",
                  owner: '',
                },
              },
              cidade: {
                edit: true,
                id: 'cidade',
                entity: 'Cidade',
                name: 'cidade',
                group: 'group_dados',
                field: 'cidade',
                type: 'entity',
                space: 6,

                required: true,
                rowEdit: false,
                title: utils.lng('cidade','Cidade'),
                label: utils.lng('cidade','Cidade'),
                attrs: {
                  owner: '',
                },
              },
              tipo: {
                id: 'tipo',
                //edit: true,
                //itemValue: 'value',
                //itemLabel: 'label',
                entity: 'TipoEndereco',
                name: 'tipo',
                group: 'group_dados',
                field: 'tipo',
                type: 'select',
                space: 3,

                required: true,
                rowEdit: false,
                title: utils.lng('tipo','Tipo'),
                label: utils.lng('tipo','Tipo'),
                list: {
                  entity: 'TipoEndereco',
                  url: 'TipoEndereco'
                },
                /*
                data: [
                  {
                    label: 'Profissional',
                    value: 'PROFISSIONAL',
                    id: 1,
                  },
                  {
                    label: 'Comercial',
                    value: 'COMERCIAL',
                    id: 4,
                  },
                  {
                    label: 'Residencial',
                    value: 'RESIDENCIAL',
                    id: 3,
                  },
                  {
                    label: 'Entrega',
                    value: 'ENTREGA',
                    id: 5,
                  },
                ],
                */
                attrs: {
                  owner: '',
                },
              },
              arquivo_comprovante: {
                space: 12,
                type: 'upload',
                upload: true,
                field: 'arquivo_comprovante',
                filesLimit: 1,
                multiple: false,
                rendered: true,
                showLabel: true,
                label: utils.lng('anexar_comprovante','Anexar comprovante'),
                change: {
                  url: 'cdn/simple/upload/base64',
                  method: 'POST',
                  send: {
                    file: 'arquivo_comprovante',
                    get_only_url: false
                  },
                  target: 'comprovante'
                }
                //change: {
                //  actino: 'changeComprovanteEndereco'
                //}
              }
            },
          },
          buttons: {
            edit: true,
            id: 'buttons',
            layout: 'buttons',
            type: 'group',
            elEdit: '${true}',
            elements: {
              buttons_left: {
                id: 'buttons_left',
                styleClass: 'ui-buttons-left',
                elements: {
                  close: {
                    edit: true,
                    id: 'close',
                    theme: 'default',
                    name: 'close',
                    type: 'button',
                    elEdit: '${true}',
                    label: utils.lng('fechar','Fechar'),
                    click: {
                      entity: 'PessoaEndereco',
                      action: 'close',
                      back: false,
                      reload: [],
                    },
                  },
                  print: {
                    id: 'print',
                    theme: 'default',
                    name: 'print',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    elEdit: '${true}',
                    label: utils.lng('imprimir','Imprimir'),
                    click: {
                      entity: 'PessoaEndereco',
                      action: 'print',
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
              buttons_right: {
                id: 'buttons_right',
                styleClass: 'ui-buttons-right',
                elements: {
                  confirm: {
                    id: 'confirm',
                    theme: 'primary',
                    name: 'confirm',
                    type: 'button',
                    label: utils.lng('confirmar','Confirmar'),
                    click: {
                      entity: 'PessoaEndereco',
                      action: 'confirm',
                      validate: true,
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  };

  const editPessoaTelefone = {
    id: 'edit',
    rendered: '${crud.edit}',
    space: 12,
    elements: {
      form: {
        id: 'form',
        layout: 'form',
        type: 'form',
        space: 12,
        elements: {
          tabs: {
            index: 0,
            id: 'tabs',
            layout: 'tab',
            type: 'tab',
            rendered: '#{}',
            visible: false,
            elements: {
              tab_group_dados: {
                index: 0,
                id: 'tab_group_dados',
                layout: 'item',
                target: 'group_dados',
                type: 'item',
                label: utils.lng('business_data','Business data'),
                click: {
                  action: 'setTab',
                },
              },
            },
          },
          group_dados: {
            index: 0,
            id: 'group_dados',
            layout: 'group',
            name: 'group_dados',
            type: 'tabItem',
            label: utils.lng('business_data','Business data'),
            elements: {
              session_group_dados_session_dados: {
                id: 'session_group_dados_session_dados',
                type: 'card',
                space: 12,
                label: utils.lng('registration_data','Registration data'),
                elements: {
                  id: {
                    edit: true,
                    id: 'id',
                    entity: 'Integer',
                    name: 'id',
                    group: 'group_dados',
                    field: 'id',
                    type: 'number',
                    space: 3,
                    visible: false,
                    required: true,
                    rowEdit: false,
                    title: 'Código',
                    label: utils.lng('codigo','Code'),
                    attrs: {
                      owner: '',
                    },
                  },
                  ddi: {
                    edit: true,
                    id: 'ddi',
                    entity: 'String',
                    name: 'ddi',
                    group: 'group_dados',
                    field: 'ddi',
                    mask: '999',
                    type: 'text',
                    space: 3,
                    visible: true,
                    rowEdit: false,
                    title: utils.lng('ddi','DDI'),
                    label: utils.lng('ddi','DDI'),
                    attrs: {
                      required: "${utils.getUser().codigo_pais_filial !== 'BRA'}",
                      owner: '',
                    },
                  },
                  ddd: {
                    edit: true,
                    id: 'ddd',
                    entity: 'String',
                    name: 'ddd',
                    group: 'group_dados',
                    field: 'ddd',
                    mask: '999',
                    type: 'text',
                    space: 3,
                    visible: true,
                    required: true,
                    rowEdit: false,
                    title: 'DDD',
                    label: utils.lng('codigo_area','Area code'),
                    attrs: {
                      owner: '',
                    },
                  },
                  telefone: {
                    edit: true,
                    id: 'telefone',
                    entity: 'String',
                    name: 'telefone',
                    group: 'group_dados',
                    field: 'telefone',
                    mask: '99999-9999',
                    type: 'text',
                    space: 3,
                    visible: true,
                    required: true,
                    rowEdit: false,
                    title: 'Telefone',
                    label: utils.lng('fone','Phone'),
                    attrs: {
                      owner: '',
                    },
                  },
                  ramal: {
                    edit: true,
                    id: 'ramal',
                    entity: 'String',
                    name: 'ramal',
                    group: 'group_dados',
                    field: 'ramal',
                    mask: '99999',
                    type: 'text',
                    space: 3,
                    visible: true,
                    rowEdit: false,
                    title: 'Ramal',
                    label: utils.lng('ramal','Ramal'),
                    attrs: {
                      owner: '',
                    },
                  },
                  tipo: {
                    //edit: true,
                    id: 'tipo',
                    entity: 'EnumTipoTelefone',
                    name: 'tipo',
                    group: 'group_dados',
                    field: 'tipo',
                    type: 'select',
                    space: 3,
                    visible: true,
                    required: true,
                    rowEdit: false,
                    title: 'Tipo',
                    label: utils.lng('tipo','Type'),
                    /*
                    list: {
                      entity: 'EnumTipoTelefone',
                      url: 'EnumTipoTelefone'
                    },
                    */
                    data: [
                      {
                        label: utils.lng('residencial','Residencial'),
                        value: 'RESIDENCIAL',
                      },
                      {
                        label: utils.lng('fax','Fax'),
                        value: 'FAX',
                      },
                      {
                        label: utils.lng('comercial','Comercial'),
                        value: 'COMERCIAL',
                      },
                      {
                        label: utils.lng('celular','Celular (Whatsapp)'),
                        value: 'CELULAR',
                      },
                      {
                        label: utils.lng('adicional','Adicional'),
                        value: 'ADICIONAL',
                      },
                      {
                        label: utils.lng('principal','Principal'),
                        value: 'PRINCIPAL',
                      },
                      {
                        label: utils.lng('contato','Contact'),
                        value: 'CONTATO',
                      },
                      {
                        label: utils.lng('telefone','Phone'),
                        value: 'TELEFONE',
                      },
                    ],
                    attrs: {
                      owner: '',
                    },
                  },
                },
              },
            },
          },

          buttons: {
            edit: true,
            id: 'buttons',
            layout: 'buttons',
            type: 'group',
            elEdit: '${true}',
            elements: {
              buttons_left: {
                id: 'buttons_left',
                styleClass: 'ui-buttons-left',
                elements: {
                  close: {
                    edit: true,
                    id: 'close',
                    theme: 'default',
                    name: 'close',
                    type: 'button',
                    elEdit: '${true}',
                    label: utils.lng('fechar','Fechar'),
                    click: {
                      entity: 'PessoaTelefone',
                      action: 'close',
                      back: false,
                      reload: [],
                    },
                  },
                  print: {
                    id: 'print',
                    theme: 'default',
                    name: 'print',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    elEdit: '${true}',
                    label: utils.lng('imprimir','Imprimir'),
                    click: {
                      entity: 'PessoaTelefone',
                      action: 'print',
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
              buttons_right: {
                id: 'buttons_right',
                styleClass: 'ui-buttons-right',
                elements: {
                  confirm: {
                    id: 'confirm',
                    theme: 'primary',
                    name: 'confirm',
                    type: 'button',
                    label: utils.lng('confirmar','Confirmar'),
                    click: {
                      entity: 'PessoaTelefone',
                      action: 'confirm',
                      validate: true,
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  };

  const editPessoaEmail = {
    id: 'edit',
    rendered: '${crud.edit}',
    space: 12,
    elements: {
      form: {
        id: 'form',
        layout: 'form',
        type: 'form',
        space: 12,
        elements: {
          tabs: {
            index: 0,
            id: 'tabs',
            layout: 'tab',
            type: 'tab',
            rendered: '#{}',
            visible: false,
            elements: {
              tab_group_dados: {
                index: 0,
                id: 'tab_group_dados',
                layout: 'item',
                target: 'group_dados',
                type: 'item',
                label: utils.lng('dados_comerciais','Business data'),
                click: {
                  action: 'setTab',
                },
              },
            },
          },
          group_dados: {
            index: 0,
            id: 'group_dados',
            layout: 'group',
            name: 'group_dados',
            type: 'tabItem',
            label: utils.lng('dados_comerciais','Business data'),
            elements: {
              session_group_dados_session_dados: {
                id: 'session_group_dados_session_dados',
                type: 'card',
                space: 12,
                label: utils.lng('dados_registro','Registration data'),
                elements: {
                  id: {
                    edit: true,
                    id: 'id',
                    entity: 'Integer',
                    name: 'id',
                    group: 'group_dados',
                    field: 'id',
                    type: 'number',
                    space: 3,
                    visible: false,
                    required: true,
                    rowEdit: false,
                    title: 'Código',
                    label: utils.lng('codigo','Code'),
                    attrs: {
                      owner: '',
                    },
                  },
                  tipo: {
                    edit: true,
                    id: 'tipo',
                    entity: 'EnumTipoEmail',
                    name: 'tipo',
                    group: 'group_dados',
                    field: 'tipo',
                    type: 'select',
                    space: 2,
                    visible: true,
                    required: true,
                    rowEdit: false,
                    title: 'Tipo',
                    label: utils.lng('tipo','Type'),
                    data: [
                      {
                        label: utils.lng('principal','Principal'),
                        value: 'PRINCIPAL',
                      },
                      {
                        label: utils.lng('compras','Compras'),
                        value: 'COMPRAS',
                      },
                      {
                        label: utils.lng('vendas','Sales'),
                        value: 'VENDAS',
                      },
                      {
                        label: utils.lng('financeiro','Financial'),
                        value: 'FINANCEIRO',
                      },
                      {
                        label: utils.lng('contato','Contact'),
                        value: 'CONTATO',
                      },
                    ],
                    attrs: {
                      owner: '',
                    },
                  },
                  email: {
                    edit: true,
                    id: 'email',
                    entity: 'String',
                    name: 'email',
                    group: 'group_dados',
                    field: 'email',
                    type: 'text',
                    space: 12,
                    max: 60,
                    visible: true,
                    required: true,
                    rowEdit: false,
                    title: 'Email',
                    label: utils.lng('email','E-mail'),
                    attrs: {
                      owner: '',
                    },
                  },
                },
              },
            },
          },
          buttons: {
            edit: true,
            id: 'buttons',
            layout: 'buttons',
            type: 'group',
            elEdit: '${true}',
            elements: {
              buttons_left: {
                id: 'buttons_left',
                styleClass: 'ui-buttons-left',
                elements: {
                  close: {
                    edit: true,
                    id: 'close',
                    theme: 'default',
                    name: 'close',
                    type: 'button',
                    elEdit: '${true}',
                    label: utils.lng('fechar','Fechar'),
                    click: {
                      entity: 'PessoaEmail',
                      action: 'close',
                      back: false,
                      reload: [],
                    },
                  },
                  print: {
                    id: 'print',
                    theme: 'default',
                    name: 'print',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    elEdit: '${true}',
                    label: utils.lng('imprimir','Imprimir'),
                    click: {
                      entity: 'PessoaEmail',
                      action: 'print',
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
              buttons_right: {
                id: 'buttons_right',
                styleClass: 'ui-buttons-right',
                elements: {
                  remove: {
                    id: 'remove',
                    theme: 'secondary',
                    name: 'remove',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    label: utils.lng('remover','Remover'),
                    click: {
                      entity: 'PessoaEmail',
                      prompt: 'Tem certeza que deseja excluir?',
                      url: 'PessoaEmail/{id}',
                      method: 'DELETE',
                      back: true,
                      reload: [],
                    },
                  },
                  confirm: {
                    id: 'confirm',
                    theme: 'primary',
                    name: 'confirm',
                    type: 'button',
                    label: utils.lng('confirmar','Confirmar'),
                    click: {
                      entity: 'PessoaEmail',
                      action: 'confirm',
                      validate: true,
                      back: true,
                      reload: [],
                    },
                  },
                  // create: {
                  //   id: 'create',
                  //   theme: 'primary',
                  //   name: 'create',
                  //   type: 'button',
                  //   rendered: '${crud.selected.id == 0 && !crud.new}',
                  //   label: 'Salvar',
                  //   click: {
                  //     entity: 'PessoaEmail',
                  //     url: 'PessoaEmail',
                  //     method: 'POST',
                  //     back: true,
                  //     reload: [],
                  //   },
                  // },
                  // update: {
                  //   id: 'update',
                  //   theme: 'primary',
                  //   name: 'update',
                  //   type: 'button',
                  //   rendered: '${crud.selected.id > 0}',
                  //   label: 'Salvar',
                  //   click: {
                  //     entity: 'PessoaEmail',
                  //     url: 'PessoaEmail/{id}',
                  //     method: 'PUT',
                  //     back: true,
                  //     reload: [],
                  //   },
                  // },
                },
              },
            },
          },
        },
      },
    },
  };

  const editPessoaDadosBancarios = {
    id: 'edit',
    space: 12,
    elements: {
      form: {
        id: 'form',
        layout: 'form',
        type: 'form',
        space: 12,
        elements: {
          group_dados: {
            index: 0,
            name: 'group_dados',
            type: 'card',
            space: 12,
            label: utils.lng('dados','Dados'),
            elements: {
              banco: {
                edit: true,
                id: 'banco',
                entity: 'Banco',
                name: 'banco',
                group: 'group_dados',
                field: 'banco',
                type: 'entity',
                space: 6,
                rowEdit: false,
                title: 'Banco',
                label: utils.lng('banco','Banco'),
                attrs: { owner: '' },
              },
              conta: {
                edit: true,
                id: 'conta',
                entity: 'String',
                name: 'conta',
                group: 'group_dados',
                field: 'conta',
                type: 'text',
                space: 6,
                rowEdit: false,
                title: 'Conta',
                label: utils.lng('conta','Conta'),
                attrs: { owner: '' },
              },
              nome: {
                edit: true,
                id: 'nome',
                entity: 'String',
                name: 'nome',
                group: 'group_dados',
                field: 'nome',
                type: 'text',
                space: 6,
                rowEdit: false,
                title: 'Razão Social',
                label: utils.lng('razao_social','Razão Social'),
                attrs: { owner: '' },
              },
            },
          },
          buttons: {
            edit: true,
            id: 'buttons',
            layout: 'buttons',
            type: 'group',
            elEdit: '${true}',
            elements: {
              buttons_left: {
                id: 'buttons_left',
                styleClass: 'ui-buttons-left',
                elements: {
                  close: {
                    edit: true,
                    id: 'close',
                    theme: 'default',
                    name: 'close',
                    type: 'button',
                    elEdit: '${true}',
                    label: utils.lng('fechar','Fechar'),
                    click: {
                      entity: 'PessoaDadosBancarios',
                      action: 'close',
                      back: false,
                      reload: [],
                    },
                  },
                  print: {
                    id: 'print',
                    theme: 'default',
                    name: 'print',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    elEdit: '${true}',
                    label: utils.lng('imprimir','Imprimir'),
                    click: {
                      entity: 'PessoaDadosBancarios',
                      action: 'print',
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
              buttons_right: {
                id: 'buttons_right',
                styleClass: 'ui-buttons-right',
                elements: {
                  confirm: {
                    id: 'confirm',
                    theme: 'primary',
                    name: 'confirm',
                    type: 'button',
                    label: utils.lng('confirmar','Confirmar'),
                    click: {
                      entity: 'PessoaDadosBancarios',
                      action: 'confirm',
                      validate: true,
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  };

  const editPessoaDocumento = {
    id: 'edit',
    rendered: '${crud.edit}',
    space: 12,
    elements: {
      form: {
        id: 'form',
        layout: 'form',
        type: 'form',
        space: 12,
        elements: {
          tabs: {
            index: 0,
            id: 'tabs',
            layout: 'tab',
            type: 'tab',
            rendered: '#{}',
            visible: false,
            elements: {
              tab_group_dados: {
                index: 0,
                id: 'tab_group_dados',
                layout: 'item',
                target: 'group_dados',
                type: 'item',
                label: utils.lng('dados_comerciais','Datos Comerciales'),
                click: {
                  action: 'setTab',
                },
              },
            },
          },
          group_dados: {
            index: 0,
            id: 'group_dados',
            layout: 'group',
            name: 'group_dados',
            type: 'tabItem',
            label: utils.lng('dados_comerciais','Datos Comerciales'),
            elements: {
              session_group_dados_session_dados: {
                id: 'session_group_dados_session_dados',
                type: 'card',
                space: 12,
                label: utils.lng('dados_registro','Datos de Registro'),
                elements: {
                  dhRegistro: {
                    edit: true,
                    id: 'dhRegistro',
                    entity: 'String',
                    name: 'dhRegistro',
                    group: 'group_dados',
                    field: 'dhRegistro',
                    type: 'datetime',
                    space: 6,
                    visible: true,
                    rowEdit: false,
                    title: 'Data registro',
                    label: utils.lng('data_registro','Fecha de Registro'),
                    attrs: {
                      owner: '',
                    },
                  },
                  id: {
                    edit: true,
                    id: 'id',
                    entity: 'Integer',
                    name: 'id',
                    group: 'group_dados',
                    field: 'id',
                    type: 'number',
                    space: 3,
                    visible: false,
                    required: true,
                    rowEdit: false,
                    title: 'Código',
                    label: utils.lng('codigo','Código'),
                    attrs: {
                      owner: '',
                    },
                  },
                  tipo: {
                    id: 'tipo',
                    //edit: true,
                    //itemValue: 'constante',
                    //itemLabel: 'descricao',
                    //rowEdit: true,
                    entity: 'TipoDocumentoPessoa',
                    name: 'tipo',
                    group: 'group_dados',
                    field: 'tipo',
                    type: 'entity',
                    space: 12,
                    visible: true,
                    required: true,
                    title: 'Tipo',
                    label: 'Tipo',
                    list: {
                      entity: 'TipoDocumentoPessoa',
                      url: 'TipoDocumentoPessoa'
                    },
                    /*
                    data: [
                      {
                        label: 'Carteira de Trabalho e Previdência Social',
                        value: 'CTPS',
                      },
                      {
                        label: 'CNH*',
                        value: 'CNH',
                      },
                      {
                        label: 'Comprovante de Conta Bancária',
                        value: 'CONTA',
                      },
                      {
                        label: 'Comprovante de Endereço - Residêncial*',
                        value: 'CE',
                      },
                      {
                        label: 'Comprovante de Estado Civil*',
                        value: 'CNC',
                      },
                      {
                        label: 'CPF*',
                        value: 'CPF',
                      },
                      {
                        label: 'Identidade de Classe',
                        value: 'IC',
                      },
                      {
                        label: 'Passaporte',
                        value: 'PASS',
                      },
                      {
                        label: 'Procuração',
                        value: 'PROC',
                      },
                      {
                        label: 'RG*',
                        value: 'RG',
                      },
                      {
                        label: 'RG (FRENTE)',
                        value: 'RGF',
                      },
                      {
                        label: 'RG (VERSO)',
                        value: 'RGV',
                      },
                    ],
                    attrs: {
                      dataSource: 'listarTipodocumentoPessoaPaisUsuario',
                      owner: '',
                    },
                    */
                  },
                  url: {
                    edit: true,
                    id: 'url',
                    entity: 'String',
                    target: '',
                    name: 'url',
                    group: 'group_dados',
                    field: 'url',
                    type: 'file',
                    help: '',
                    space: 12,
                    upload: true,
                    visible: true,
                    required: true,
                    showLabel: false,
                    rowEdit: false,
                    title: 'Comprovante',
                    label: utils.lng('comprovante','Comprovante'),
                    attrs: {
                      googlePreview: false,
                      owner: '',
                    },
                  },
                },
              },
            },
          },
          buttons: {
            edit: true,
            id: 'buttons',
            layout: 'buttons',
            type: 'group',
            elEdit: '${true}',
            elements: {
              buttons_left: {
                id: 'buttons_left',
                styleClass: 'ui-buttons-left',
                elements: {
                  close: {
                    edit: true,
                    id: 'close',
                    theme: 'default',
                    name: 'close',
                    type: 'button',
                    elEdit: '${true}',
                    label: utils.lng('fechar','Fechar'),
                    click: {
                      entity: 'PessoaDocumento',
                      action: 'close',
                      back: false,
                      reload: [],
                    },
                  },
                  print: {
                    id: 'print',
                    theme: 'default',
                    name: 'print',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    elEdit: '${true}',
                    label: utils.lng('imprimir','Imprimir'),
                    click: {
                      entity: 'PessoaDocumento',
                      action: 'print',
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
              buttons_right: {
                id: 'buttons_right',
                styleClass: 'ui-buttons-right',
                elements: {
                  remove: {
                    id: 'remove',
                    theme: 'secondary',
                    name: 'remove',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    label: utils.lng('remover','Remover'),
                    click: {
                      entity: 'PessoaDocumento',
                      prompt: 'Tem certeza que deseja excluir?',
                      url: 'PessoaDocumento/{id}',
                      method: 'DELETE',
                      back: true,
                      reload: [],
                    },
                  },
                  confirm: {
                    id: 'confirm',
                    theme: 'primary',
                    name: 'confirm',
                    type: 'button',
                    // rendered: '${crud.selected.id <= 0 && crud.new}',
                    label: utils.lng('confirmar','Confirmar'),
                    click: {
                      entity: 'PessoaDocumento',
                      action: 'confirm',
                      validate: true,
                      back: true,
                      reload: [],
                    },
                  },
                  // create: {
                  //   id: 'create',
                  //   theme: 'primary',
                  //   name: 'create',
                  //   type: 'button',
                  //   rendered: '${crud.selected.id == 0 && !crud.new}',
                  //   label: 'Salvar',
                  //   click: {
                  //     entity: 'PessoaDocumento',
                  //     url: 'PessoaDocumento',
                  //     method: 'POST',
                  //     back: true,
                  //     reload: [],
                  //   },
                  // },
                  // update: {
                  //   id: 'update',
                  //   theme: 'primary',
                  //   name: 'update',
                  //   type: 'button',
                  //   rendered: '${crud.selected.id > 0}',
                  //   label: 'Salvar',
                  //   click: {
                  //     entity: 'PessoaDocumento',
                  //     url: 'PessoaDocumento/{id}',
                  //     method: 'PUT',
                  //     back: true,
                  //     reload: [],
                  //   },
                  // },
                },
              },
            },
          },
        },
      },
    },
  };

  const editDocumento = {
    id: 'edit',
    rendered: '${crud.edit}',
    space: 12,
    elements: {
      form: {
        id: 'form',
        layout: 'form',
        type: 'form',
        space: 12,
        elements: {
          tabs: {
            index: 0,
            id: 'tabs',
            layout: 'tab',
            type: 'tab',
            rendered: '#{}',
            visible: false,
            elements: {
              tab_group_dados: {
                index: 0,
                id: 'tab_group_dados',
                layout: 'item',
                target: 'group_dados',
                type: 'item',
                label: utils.lng('dados_comerciais','Datos Comerciales'),
                click: {
                  action: 'setTab',
                },
              },
            },
          },
          group_dados: {
            index: 0,
            id: 'group_dados',
            layout: 'group',
            name: 'group_dados',
            type: 'tabItem',
            label: utils.lng('dados_comerciais','Datos Comerciales'),
            elements: {
              session_group_dados_session_dados: {
                id: 'session_group_dados_session_dados',
                type: 'card',
                space: 12,
                label: utils.lng('dados_registro','Datos de Registro'),
                elements: {
                  dhRegistro: {
                    edit: true,
                    id: 'dhRegistro',
                    entity: 'String',
                    name: 'dhRegistro',
                    group: 'group_dados',
                    field: 'dhRegistro',
                    type: 'datetime',
                    space: 6,
                    visible: true,
                    rowEdit: false,
                    title: 'Data registro',
                    label: utils.lng('reta_registro','Fecha de Registro'),
                    attrs: {
                      owner: '',
                    },
                  },
                  id: {
                    edit: true,
                    id: 'id',
                    entity: 'Integer',
                    name: 'id',
                    group: 'group_dados',
                    field: 'id',
                    type: 'number',
                    space: 3,
                    visible: false,
                    required: true,
                    rowEdit: false,
                    title: 'Código',
                    label: utils.lng('codigo','Código'),
                    attrs: {
                      owner: '',
                    },
                  },
                  tipo: {
                    id: 'tipo',
                    //edit: true,
                    //itemValue: 'constante',
                    //itemLabel: 'label',
                    entity: 'TipoDocumentoPessoa',
                    name: 'tipo',
                    group: 'group_dados',
                    field: 'tipo',
                    type: 'entity',
                    space: 12,
                    visible: true,
                    required: true,
                    //rowEdit: false,
                    title: 'Tipo',
                    label: 'Tipoeeeeeeeeeeeeeeeeee',
                    list: {
                      entity: 'TipoDocumentoPessoa',
                      url: 'TipoDocumentoPessoa'
                    },
                    /*
                    data: [
                      {
                        label: 'Carteira de Trabalho e Previdência Social',
                        value: 'CTPS',
                      },
                      {
                        label: 'CNH*',
                        value: 'CNH',
                      },
                      {
                        label: 'Comprovante de Conta Bancária',
                        value: 'CONTA',
                      },
                      {
                        label: 'Comprovante de Endereço - Residêncial*',
                        value: 'CE',
                      },
                      {
                        label: 'Comprovante de Estado Civil*',
                        value: 'CNC',
                      },
                      {
                        label: 'CPF*',
                        value: 'CPF',
                      },
                      {
                        label: 'Identidade de Classe',
                        value: 'IC',
                      },
                      {
                        label: 'Passaporte',
                        value: 'PASS',
                      },
                      {
                        label: 'Procuração',
                        value: 'PROC',
                      },
                      {
                        label: 'RG*',
                        value: 'RG',
                      },
                      {
                        label: 'RG (FRENTE)',
                        value: 'RGF',
                      },
                      {
                        label: 'RG (VERSO)',
                        value: 'RGV',
                      },
                    ],
                    */
                    attrs: {
                      dataSource: 'listarTipodocumentoPessoaPaisUsuario',
                      owner: '',
                    },
                  },
                  url: {
                    edit: true,
                    id: 'url',
                    entity: 'String',
                    target: '',
                    name: 'url',
                    group: 'group_dados',
                    field: 'url',
                    type: 'file',
                    help: '',
                    space: 12,
                    upload: true,
                    visible: true,
                    required: true,
                    showLabel: false,
                    rowEdit: false,
                    title: 'Comprovante',
                    label: utils.lng('comprovante','Comprovante'),
                    attrs: {
                      googlePreview: false,
                      owner: '',
                    },
                  },
                },
              },
            },
          },
          buttons: {
            edit: true,
            id: 'buttons',
            layout: 'buttons',
            type: 'group',
            elEdit: '${true}',
            elements: {
              buttons_left: {
                id: 'buttons_left',
                styleClass: 'ui-buttons-left',
                elements: {
                  close: {
                    edit: true,
                    id: 'close',
                    theme: 'default',
                    name: 'close',
                    type: 'button',
                    elEdit: '${true}',
                    label: utils.lng('fechar','Fechar'),
                    click: {
                      entity: 'PessoaDocumento',
                      action: 'close',
                      back: false,
                      reload: [],
                    },
                  },
                  print: {
                    id: 'print',
                    theme: 'default',
                    name: 'print',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    elEdit: '${true}',
                    label: utils.lng('imprimir','Imprimir'),
                    click: {
                      entity: 'PessoaDocumento',
                      action: 'print',
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
              buttons_right: {
                id: 'buttons_right',
                styleClass: 'ui-buttons-right',
                elements: {
                  remove: {
                    id: 'remove',
                    theme: 'secondary',
                    name: 'remove',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    label: utils.lng('remover','Remover'),
                    click: {
                      entity: 'PessoaDocumento',
                      prompt: 'Tem certeza que deseja excluir?',
                      url: 'PessoaDocumento/{id}',
                      method: 'DELETE',
                      back: true,
                      reload: [],
                    },
                  },
                  confirm: {
                    id: 'confirm',
                    theme: 'primary',
                    name: 'confirm',
                    type: 'button',
                    // rendered: '${crud.selected.id <= 0 && crud.new}',
                    label: utils.lng('confirmar','Confirmar'),
                    click: {
                      entity: 'PessoaDocumento',
                      action: 'confirm',
                      validate: true,
                      back: true,
                      reload: [],
                    },
                  },
                  // create: {
                  //   id: 'create',
                  //   theme: 'primary',
                  //   name: 'create',
                  //   type: 'button',
                  //   rendered: '${crud.selected.id == 0 && !crud.new}',
                  //   label: 'Salvar',
                  //   click: {
                  //     entity: 'PessoaDocumento',
                  //     url: 'PessoaDocumento',
                  //     method: 'POST',
                  //     back: true,
                  //     reload: [],
                  //   },
                  // },
                  // update: {
                  //   id: 'update',
                  //   theme: 'primary',
                  //   name: 'update',
                  //   type: 'button',
                  //   rendered: '${crud.selected.id > 0}',
                  //   label: 'Salvar',
                  //   click: {
                  //     entity: 'PessoaDocumento',
                  //     url: 'PessoaDocumento/{id}',
                  //     method: 'PUT',
                  //     back: true,
                  //     reload: [],
                  //   },
                  // },
                },
              },
            },
          },
        },
      },
    },
  };

  const editPessoaSocio = {
    id: 'edit',
    rendered: '${crud.edit}',
    space: 12,
    elements: {
      form: {
        id: 'form',
        layout: 'form',
        type: 'form',
        space: 12,
        elements: {
          tabs: {
            index: 0,
            id: 'tabs',
            layout: 'tab',
            type: 'tab',
            rendered: '#{}',
            visible: false,
            elements: {
              tab_group_dados: {
                index: 0,
                id: 'tab_group_dados',
                layout: 'item',
                target: 'group_dados',
                type: 'item',
                label: utils.lng('dados_comerciais','Datos Comerciales'),
                click: {
                  action: 'setTab',
                },
              },
            },
          },
          group_dados: {
            index: 0,
            id: 'group_dados',
            layout: 'group',
            name: 'group_dados',
            type: 'tabItem',
            label: utils.lng('dados_comerciais','Datos Comerciales'),
            elements: {
              session_group_dados_session_dados: {
                id: 'session_group_dados_session_dados',
                type: 'card',
                space: 12,
                label: utils.lng('dados_registro','Datos de Registro'),
                elements: {
                  dhRegistro: {
                    edit: true,
                    id: 'dhRegistro',
                    entity: 'Date',
                    name: 'dhRegistro',
                    group: 'group_dados',
                    field: 'dhRegistro',
                    type: 'datetime',
                    space: -1,
                    visible: true,
                    rowEdit: false,
                    title: 'Data registro',
                    label: utils.lng('dados_registro','Fecha de Registro'),
                    attrs: {
                      owner: '',
                    },
                  },
                  id: {
                    edit: true,
                    id: 'id',
                    entity: 'Integer',
                    name: 'id',
                    group: 'group_dados',
                    field: 'id',
                    type: 'number',
                    help: 'São Obrigatórios >> \n1. Comprovante de Cadastro da empresa; \n2. Comprovante de endereço;',
                    space: 3,
                    visible: false,
                    required: true,
                    rowEdit: false,
                    title: 'Código',
                    label: utils.lng('codigo','Código'),
                    attrs: {
                      owner: '',
                    },
                  },
                  tipoDocumento: {
                    id: 'tipoDocumento',
                    //edit: true,
                    //itemValue: 'id',
                    //itemLabel: 'label',
                    entity: 'TipoDocumento',
                    name: 'tipoDocumento',
                    group: 'group_dados',
                    field: 'tipoDocumento',
                    type: 'entity',
                    space: 12,
                    visible: true,
                    rowEdit: false,
                    title: 'Tipo',
                    label: utils.lng('tipo','Tipo'),
                    list: {
                      entity: 'TipoDocumento',
                      url: 'TipoDocumento'
                    },
                    /*
                    data: [
                      {
                        label: 'Certificado de Micro Empresa(MEI)*',
                        value: '2',
                      },
                      {
                        label: 'Comprovante de CNPJ*',
                        value: '4',
                      },
                      {
                        label: 'Comprovante de Conta Bancária',
                        value: '14',
                      },
                      {
                        label: 'Comprovante de Endereço da Empresa*',
                        value: '5',
                      },
                      {
                        label: 'Comprovante participação - Outras marcas',
                        value: '16',
                      },
                      {
                        label: 'Contrato de Distribuidor (6 páginas)',
                        value: '11',
                      },
                      {
                        label: 'Contrato de SPV ( D.I. X NIPPONFLEX - 3 Páginas) ',
                        value: '10',
                      },
                      {
                        label: 'Contrato de SPV (NIPPONFLEX X D.I. - 4 Páginas) ',
                        value: '12',
                      },
                      {
                        label: 'Contrato Social*',
                        value: '3',
                      },
                      {
                        label: 'Ficha de cadastro',
                        value: '13',
                      },
                      {
                        label: 'Requerimento de Empresário*',
                        value: '6',
                      },
                      {
                        label: 'Simples Nacional',
                        value: '8',
                      },
                      {
                        label: 'Sintegra',
                        value: '7',
                      },
                    ],
                    */
                    attrs: {
                      dataSource: 'listarTipodocumentoPaisUsuario',
                      owner: '',
                    },
                  },
                  caminho: {
                    edit: true,
                    id: 'caminho',
                    entity: 'String',
                    name: 'caminho',
                    group: 'group_dados',
                    field: 'caminho',
                    type: 'file',
                    space: 12,
                    upload: true,
                    visible: true,
                    required: true,
                    rowEdit: false,
                    title: 'Caminho',
                    label: utils.lng('caminho','Caminho'),
                    attrs: {
                      acceptedFiles: [],
                      upload: {
                        value: 'caminho',
                        extension: 'extensao',
                        name: ['descricao', 'nome'],
                        size: 'tamanhoBytes',
                      },
                      googlePreview: false,
                      owner: '',
                    },
                  },
                  observacao: {
                    edit: true,
                    id: 'observacao',
                    entity: 'String',
                    name: 'observacao',
                    group: 'group_dados',
                    field: 'observacao',
                    type: 'textarea',
                    space: 12,
                    visible: true,
                    rowEdit: false,
                    title: 'Observação',
                    label: utils.lng('observacao','Observación'),
                    attrs: {
                      owner: '',
                    },
                  },
                },
              },
            },
          },
          buttons: {
            edit: true,
            id: 'buttons',
            layout: 'buttons',
            type: 'group',
            elEdit: '${true}',
            elements: {
              buttons_left: {
                id: 'buttons_left',
                styleClass: 'ui-buttons-left',
                elements: {
                  close: {
                    edit: true,
                    id: 'close',
                    theme: 'default',
                    name: 'close',
                    type: 'button',
                    elEdit: '${true}',
                    label: utils.lng('fechar','Fechar'),
                    click: {
                      entity: 'Documento',
                      action: 'close',
                      back: false,
                      reload: [],
                    },
                  },
                  print: {
                    id: 'print',
                    theme: 'default',
                    name: 'print',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    elEdit: '${true}',
                    label: utils.lng('imprimir','Imprimir'),
                    click: {
                      entity: 'Documento',
                      action: 'print',
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
              buttons_right: {
                id: 'buttons_right',
                styleClass: 'ui-buttons-right',
                elements: {
                  remove: {
                    id: 'remove',
                    theme: 'secondary',
                    name: 'remove',
                    type: 'button',
                    rendered: '${crud.selected.id > 0}',
                    label: utils.lng('remover','Remover'),
                    click: {
                      entity: 'Documento',
                      prompt: 'Tem certeza que deseja excluir?',
                      url: 'Documento/{id}',
                      method: 'DELETE',
                      back: true,
                      reload: [],
                    },
                  },
                  confirm: {
                    id: 'confirm',
                    theme: 'primary',
                    name: 'confirm',
                    type: 'button',
                    // rendered: "${crud.selected.id <= 0 && crud.new}",
                    label: utils.lng('confirmar','Confirmar'),
                    click: {
                      entity: 'Documento',
                      action: 'confirm',
                      validate: true,
                      back: true,
                      reload: [],
                    },
                  },
                  // create: {
                  //   id: "create",
                  //   theme: "primary",
                  //   name: "create",
                  //   type: "button",
                  //   rendered: "${crud.selected.id == 0 && !crud.new}",
                  //   label: "Salvar",
                  //   click: {
                  //     entity: "Documento",
                  //     url: "Documento",
                  //     method: "POST",
                  //     back: true,
                  //     reload: []
                  //   }
                  // },
                  // update: {
                  //   id: "update",
                  //   theme: "primary",
                  //   name: "update",
                  //   type: "button",
                  //   rendered: "${crud.selected.id > 0}",
                  //   label: "Salvar",
                  //   click: {
                  //     entity: "Documento",
                  //     url: "Documento/{id}",
                  //     method: "PUT",
                  //     back: true,
                  //     reload: []
                  //   }
                  // }
                },
              },
            },
          },
        },
      },
    },
  };

  usuario.entity = 'Usuario';
  usuario.label = utils.lng('meus_dados', 'Meus dados');
  usuario.path = 'meus_dados';
  usuario.id = id;
  usuario.eager = true;
  usuario.selected.id = id;
  usuario.name = 'meus_dados';
  usuario.element = {
    top: {
      include: 'tabs',
    },
    edit: true,
    crud: 52,
    itemVar: 'obj',
    entity: 'Usuario',
    name: 'Usuario',
    alias: 'meus_dados',
    type: 'crud',
    processo: 117,
    space: 12,
    delete: false,
    open: false,
    add: true,
    title: 'Usuario',
    label: utils.lng('usuario','Usuario'),
    elements: {
      edit: {
        id: 'edit',
        rendered: '${crud.edit}',
        space: 12,
        elements: {
          form: {
            id: 'form',
            layout: 'form',
            type: 'form',
            space: 12,
            elements: {
              tabs: {
                index: 0,
                id: 'tabs',
                layout: 'tab',
                type: 'tab',
                elements: {
                  tab_group_dados: {
                    index: 0,
                    id: 'tab_group_dados',
                    layout: 'item',
                    target: 'group_dados',
                    type: 'item',
                    label: utils.lng('dados','Dados'),
                    click: {
                      action: 'setTab',
                    },
                  },
                  tab_group_contatos: {
                    index: 1,
                    id: 'tab_group_contatos',
                    layout: 'item',
                    target: 'group_contatos',
                    type: 'item',
                    label: utils.lng('contatos','Contatos'),
                    click: {
                      action: 'setTab',
                    },
                  },
                  tab_group_enderecos: {
                    index: 2,
                    id: 'tab_group_enderecos',
                    layout: 'item',
                    target: 'group_enderecos',
                    type: 'item',
                    label: utils.lng('enderecos','Endereços'),
                    click: {
                      action: 'setTab',
                    },
                  },
                  tab_group_contas: {
                    index: 3,
                    id: 'tab_group_contas',
                    layout: 'item',
                    target: 'group_contas',
                    type: 'item',
                    label: utils.lng('dados_bancarios','Dados Bancários'),
                    click: {
                      action: 'setTab',
                    },
                  },
                  tab_group_documentos: {
                    index: 4,
                    id: 'tab_group_documentos',
                    layout: 'item',
                    target: 'group_documentos',
                    type: 'item',
                    label: utils.lng('documentos','Documentos'),
                    click: {
                      action: 'setTab',
                    },
                  },
                  tab_group_socios: {
                    index: 5,
                    id: 'tab_group_socios',
                    layout: 'item',
                    target: 'group_socios',
                    type: 'item',
                    label: utils.lng('socios','Sócios'),
                    click: {
                      action: 'setTab',
                    },
                  },
                },
              },
              group_dados: {
                index: 0,
                id: 'group_dados',
                layout: 'group',
                name: 'group_dados',
                type: 'tabItem',
                label: utils.lng('dados','Dados'),
                elements: {
                  session_group_dados_session_dados: {
                    id: 'session_group_dados_session_dados',
                    type: 'card',
                    space: 12,
                    label: utils.lng('dados_cadastrais','Dados cadastrais'),
                    elements: {
                      filialCliente: {
                        edit: true,
                        id: 'filialCliente',
                        entity: 'Filial',
                        name: 'filialCliente',
                        group: 'group_dados',
                        field: 'filialCliente',
                        type: 'entity',
                        space: -1,

                        rowEdit: false,
                        title: utils.lng('filial','Filial'),
                        label: utils.lng('filial','Filial'),
                        attrs: {
                          disabled: true,
                          owner: '',
                        },
                      },
                      avatar: {
                        edit: true,
                        id: 'avatar',
                        entity: 'String',
                        target: '',
                        name: 'avatar',
                        group: 'group_dados',
                        field: 'avatar',
                        type: 'file',
                        help: '',
                        space: 12,
                        dialog: true,
                        upload: true,

                        showLabel: false,
                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: ' Avatar',
                        label: utils.lng('avatar','Avatar'),
                        attrs: {
                          googlePreview: false,
                          owner: '',
                        },
                      },
                      apelido: {
                        edit: true,
                        id: 'apelido',
                        entity: 'String',
                        name: 'apelido',
                        group: 'group_dados',
                        field: 'apelido',
                        type: 'text',
                        space: 6,

                        rowEdit: false,
                        title: utils.lng('apelido','Apelido'),
                        label: utils.lng('apelido','Apelido'),
                        attrs: {
                          owner: '',
                        },
                      },
                      email: {
                        edit: true,
                        id: 'email',
                        entity: 'String',
                        target: '',
                        name: 'email',
                        group: 'group_dados',
                        field: 'email',
                        type: 'text',
                        help: '',
                        space: 6,

                        required: true,
                        showLabel: false,
                        rowEdit: false,
                        title: utils.lng('email','Email'),
                        label: utils.lng('email','Email'),
                        attrs: {
                          owner: '',
                        },
                      },
                      digiteSenha: {
                        edit: true,
                        id: 'digiteSenha',
                        entity: 'String',
                        target: '',
                        name: 'digiteSenha',
                        group: 'group_dados',
                        field: 'digiteSenha',
                        type: 'password',
                        help: '',
                        space: 6,

                        showLabel: false,
                        rowEdit: false,
                        title: utils.lng('digite_senha','Digite sua senha'),
                        label: utils.lng('digite_senha','Digite sua senha'),
                        attrs: {
                          owner: '',
                        },
                      },
                      confirmeSenha: {
                        edit: true,
                        id: 'confirmeSenha',
                        entity: 'String',
                        target: '',
                        name: 'confirmeSenha',
                        group: 'group_dados',
                        field: 'confirmeSenha',
                        type: 'password',
                        help: '',
                        space: 6,

                        showLabel: false,
                        rowEdit: false,
                        title: utils.lng('confirme_senha','Confirme sua senha'),
                        label: utils.lng('confirme_senha','Confirme sua senha'),
                        attrs: {
                          owner: '',
                        },
                      },
                      pessoa_codigo: {
                        edit: true,
                        id: 'pessoa_codigo',
                        entity: 'String',
                        name: 'codigo',
                        group: 'group_dados',
                        field: 'pessoa.codigo',
                        type: 'text',
                        space: 6,

                        //required: true,
                        disabled: true,
                        rowEdit: false,
                        title: utils.lng('codigo_mundial','Código mundial'),
                        label: utils.lng('codigo_mundial','Código mundial'),
                        attrs: {
                          disabled: true,
                          owner: 'pessoa',
                        },
                      },
                      pessoa_pessoaJuridica_cnpj: {
                        edit: true,
                        id: 'pessoa_pessoaJuridica_cnpj',
                        entity: 'String',
                        target: '',
                        name: 'pessoaJuridica.cnpj',
                        group: 'group_dados',
                        field: 'pessoa.pessoaJuridica.cnpj',
                        mask: '99.999.999/9999-99',
                        type: 'text',
                        help: '',
                        rendered: "#{pessoa.tipo.constante == 'PJ'}",
                        space: 6,
                        min: 13,

                        showLabel: false,
                        //rowEdit: false,
                        title: utils.lng('cnpm','CNPJ'),
                        label: utils.lng('cnpj','CNPJ'),
                        attrs: {
                          //disabled: true,
                          change: {
                            url: 'consultarCNPJ',
                            send: {
                              cnpj: '#{@this.pessoa.pessoaJuridica.cnpj}',
                              filtrar_pais: true,
                            },
                            target: 'pessoa',
                          },
                          owner: 'pessoa',
                        },
                      },
                      pessoa_pessoaJuridica_ie: {
                        edit: true,
                        id: 'pessoa_pessoaJuridica_ie',
                        entity: 'String',
                        name: 'ie',
                        group: 'group_dados',
                        field: 'pessoa.pessoaJuridica.ie',
                        type: 'text',
                        rendered: "#{pessoa.tipo.constante == 'PJ' }",
                        space: 6,

                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO' && user.tipo !== 'CLIENTE'}",
                        title: utils.lng('ie','IE'),
                        label: utils.lng('ie','IE'),
                        attrs: {
                          owner: 'pessoa.pessoaJuridica',
                        },
                      },
                      pessoa_pessoaJuridica_regimeEspecial: {
                        id: 'pessoa_pessoaJuridica_regimeEspecial',
                        //edit: true,
                        //itemValue: 'value',
                        //itemLabel: 'label',
                        entity: 'RegimeEspecial',
                        name: 'regimeEspecial',
                        group: 'group_dados',
                        field: 'pessoa.pessoaJuridica.regimeEspecial',
                        type: 'select',
                        rendered: "#{pessoa.tipo.constante == 'PJ' }",
                        space: 3,

                        rowEdit: false,
                        //elEdit: "${user.status_penn !== 'INATIVO' && user.tipo !== 'CLIENTE'}",
                        title: utils.lng('regime_especial','Regime Especial'),
                        label: utils.lng('regime_especial','Regime Especial'),
                        list: {
                          entity: 'RegimeEspecial',
                          url: 'RegimeEspecial'
                        },
                        /*
                        data: [
                          {
                            label: 'Nenhum',
                            value: 'NENHUM',
                            id: 7,
                          },
                          {
                            label: 'Micro Empresa Municipal',
                            value: 'MICRO_EMPRESA_MUNICIPAL',
                            id: 1,
                          },
                          {
                            label: 'Estimativa',
                            value: 'ESTIMATIVA',
                            id: 2,
                          },
                          {
                            label: 'Sociedade de Profissionais',
                            value: 'SOCIEDADE_PROFISSIONAIS',
                            id: 3,
                          },
                          {
                            label: 'Cooperativa',
                            value: 'COOPERATIVA',
                            id: 4,
                          },
                          {
                            label: 'Microempresário Individual (MEI)',
                            value: 'MEI',
                            id: 5,
                          },
                          {
                            label: 'Microempresário e Empresa de pequeno porte (ME EPP)',
                            value: 'ME_EPP',
                            id: 6,
                          },
                        ],
                        */
                        attrs: {
                          owner: 'pessoa.pessoaJuridica',
                        },
                      },
                      pessoa_nome: {
                        edit: true,
                        id: 'pessoa_nome',
                        entity: 'String',
                        name: 'nome',
                        group: 'group_dados',
                        field: 'pessoa.nome',
                        type: 'text',
                        space: 6,
                        max: 12,
                        size: 1,

                        required: true,
                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('nome','Nome'),
                        label: utils.lng('nome','Nome'),
                        attrs: {
                          owner: 'pessoa',
                        },
                      },
                      pessoa_pessoaJuridica_regimeTributario: {
                        id: 'pessoa_pessoaJuridica_regimeTributario',
                        //edit: true,
                        //itemValue: 'value',
                        //itemLabel: 'label',
                        entity: 'RegimeTributario',
                        name: 'regimeTributario',
                        group: 'group_dados',
                        field: 'pessoa.pessoaJuridica.regimeTributario',
                        type: 'select',
                        rendered: "#{pessoa.tipo.constante == 'PJ' }",
                        space: 3,

                        //rowEdit: false,
                        //elEdit: "${user.status_penn !== 'INATIVO' && user.tipo !== 'CLIENTE'}",
                        title: utils.lng('regime_tributario','Regime Tributario'),
                        label: utils.lng('regime_tributario','Regime Tributario'),
                        list: {
                          entity: 'RegimeTributario',
                          url: 'RegimeTributario'
                        },
                        /*
                        data: [
                          {
                            label: 'Simples Nacional',
                            value: 'SIMPLES_NACIONAL',
                            id: 1,
                          },
                          {
                            label: 'Simples Nacional Excesso de Sublimite de Receita Bruta',
                            value: 'SIMPLES_NACIONAL_EXCESSO',
                            id: 2,
                          },
                          {
                            label: 'Regime Normal',
                            value: 'REGIME_NORMAL',
                            id: 3,
                          },
                        ],
                        */
                        attrs: {
                          owner: 'pessoa.pessoaJuridica',
                        },
                      },
                      pessoa_pessoaFisica_cpf: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_cpf',
                        entity: 'String',
                        name: 'cpf',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.cpf',
                        mask: '999.999.999-99',
                        type: 'text',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 6,

                        rowEdit: false,
                        title: utils.lng('cpf','CPF'),
                        label: utils.lng('cpf','CPF'),
                        attrs: {
                          disabled: '${user.perfil.id === 118}',
                          required: "${user.perfil.id !== 118 && utils.getUser().codigo_pais_filial !== 'BRA'}",
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_id: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_id',
                        entity: 'Integer',
                        name: 'id',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.id',
                        type: 'number',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 3,
                        visible: false,
                        required: true,
                        rowEdit: false,
                        title: utils.lng('codigo','Código'),
                        label: utils.lng('codigo','Código'),
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_sexo: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_sexo',
                        entity: 'EnumSexo',
                        name: 'sexo',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.sexo',
                        type: 'select',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 3,

                        rowEdit: false,
                        title: utils.lng('sexo','Sexo'),
                        label: utils.lng('sexo','Sexo'),
                        data: [
                          {
                            label: utils.lng('masculino','MASCULINO'),
                            value: 'MASCULINO',
                          },
                          {
                            label: utils.lng('feminino','FEMININO'),
                            value: 'FEMININO',
                          },
                          {
                            label: utils.lng('outro','OUTRO'),
                            value: 'OUTRO',
                          },
                        ],
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_rg: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_rg',
                        entity: 'String',
                        name: 'rg',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.rg',
                        mask: '9999999999999',
                        type: 'text',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 6,

                        rowEdit: false,
                        title: utils.lng('rg','RG'),
                        label: utils.lng('rg','RG'),
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_orgaoExpedidorRg: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_orgaoExpedidorRg',
                        entity: 'String',
                        name: 'orgaoExpedidorRg',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.orgaoExpedidorRg',
                        type: 'text',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 6,

                        rowEdit: false,
                        title: utils.lng('orgao_expedidor','Órgão Expedidor RG'),
                        label: utils.lng('orgao_expedidor','Órgão Expedidor RG'),
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_dataExpedicaoRg: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_dataExpedicaoRg',
                        entity: 'Date',
                        name: 'dataExpedicaoRg',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.dataExpedicaoRg',
                        type: 'date',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 6,

                        rowEdit: false,
                        title: utils.lng('data_expedicao','Data Expedição RG'),
                        label: utils.lng('data_expedicao','Data Expedição RG'),
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_nacionalidade: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_nacionalidade',
                        entity: 'String',
                        name: 'nacionalidade',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.nacionalidade',
                        type: 'text',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 6,

                        rowEdit: false,
                        title: utils.lng('nacionalidade','Nacionalidade'),
                        label: utils.lng('nacionalidade','Nacionalidade'),
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_naturalidade: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_naturalidade',
                        entity: 'Cidade',
                        name: 'naturalidade',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.naturalidade',
                        type: 'entity',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 6,

                        rowEdit: false,
                        title: utils.lng('naturalidade','Naturalidade'),
                        label: utils.lng('naturalidade','Naturalidade'),
                        expression: "${@this.descricao}+' - '+${@this.estado.uf}",
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_dataNascimento: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_dataNascimento',
                        entity: 'Date',
                        name: 'dataNascimento',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.dataNascimento',
                        type: 'datetime',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 3,

                        rowEdit: false,
                        title: utils.lng('data_nascimento','Data Nascimento'),
                        label: utils.lng('data_nascimento','Data Nascimento'),
                        attrs: {
                          required:
                            "${utils.getUser().codigo_pais_filial !== 'BRA' && utils.getUser().codigo_pais !== 'USA'}",
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_estadoCivil: {
                        id: 'pessoa_pessoaFisica_estadoCivil',
                        //edit: true,
                        //itemValue: 'value',
                        //itemLabel: 'label',
                        entity: 'EstadoCivil',
                        name: 'estadoCivil',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.estadoCivil',
                        type: 'select',
                        rendered: "#{pessoa.tipo.constante == 'PF' }",
                        space: 3,

                        rowEdit: false,
                        title: utils.lng('estado_civil','Estado Civil'),
                        label: utils.lng('estado_civil','Estado Civil'),
                        list: {
                          entity: 'EstadoCivil',
                          url: 'EstadoCivil'
                        },
                        /*
                        data: [
                          {
                            label: 'Solteiro',
                            value: 'SOLTEIRO',
                            id: 4,
                          },
                          {
                            label: 'Casado',
                            value: 'CASADO',
                            id: 1,
                          },
                          {
                            label: 'Desquitado',
                            value: 'DESQUITADO',
                            id: 17,
                          },
                          {
                            label: 'Divorciado',
                            value: 'DIVORCIADO',
                            id: 2,
                          },
                          {
                            label: 'Viúvo',
                            value: 'VIUVO',
                            id: 6,
                          },
                          {
                            label: 'União Estável',
                            value: 'UNIAO_ESTAVEL',
                            id: 5,
                          },
                          {
                            label: 'Separado Judicialmente',
                            value: 'SEPARADO_JUDICIALMENTE',
                            id: 3,
                          },
                        ],
                        */
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_nomeConjuge: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_nomeConjuge',
                        entity: 'String',
                        name: 'nomeConjuge',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.nomeConjuge',
                        type: 'text',
                        rendered:
                          "#{utils.contains('|CASADO|UNIAO_ESTAVEL|',pessoa.pessoaFisica.estadoCivil.constante)}",
                        space: 6,

                        required: true,
                        rowEdit: false,
                        title: utils.lng('nome_conjuge','Nome Cônjuge'),
                        label: utils.lng('nome_conjuge','Nome Cônjuge'),
                        attrs: {
                          required: "${utils.getUser().codigo_pais !== 'USA'}",
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_cpfConjuge: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_cpfConjuge',
                        entity: 'String',
                        name: 'cpfConjuge',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.cpfConjuge',
                        mask: '999.999.999-99',
                        type: 'text',
                        rendered:
                          "#{utils.contains('|CASADO|UNIAO_ESTAVEL|',pessoa.pessoaFisica.estadoCivil.constante)}",
                        space: 6,

                        required: true,
                        rowEdit: false,
                        title: utils.lng('cpf_conjuge','CPF Cônjuge'),
                        label: utils.lng('cpf_conjuge','CPF Cônjuge'),
                        attrs: {
                          overwrite: {
                            BRA: {
                              mask: '999.999.999-99',
                            },
                            default: {
                              mask: '',
                            },
                          },
                          required: "${utils.getUser().codigo_pais !== 'USA'}",
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_dataNascimentoConjuge: {
                        edit: true,
                        id: 'pessoa_pessoaFisica_dataNascimentoConjuge',
                        entity: 'Date',
                        name: 'dataNascimentoConjuge',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.dataNascimentoConjuge',
                        type: 'date',
                        rendered:
                          "#{utils.contains('|CASADO|UNIAO_ESTAVEL|',pessoa.pessoaFisica.estadoCivil.constante)}",
                        space: 6,

                        required: true,
                        rowEdit: false,
                        title: utils.lng('data_nascimento','Data Nascimento Cônjuge'),
                        label: utils.lng('data_nascimento','Data Nascimento Cônjuge'),
                        attrs: {
                          required: "${utils.getUser().codigo_pais !== 'USA'}",
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaFisica_regimeComunhaoBens: {
                        id: 'pessoa_pessoaFisica_regimeComunhaoBens',
                        //edit: true,
                        //itemValue: 'value',
                        //itemLabel: 'label',
                        entity: 'RegimeComunhaoBens',
                        name: 'regimeComunhaoBens',
                        group: 'group_dados',
                        field: 'pessoa.pessoaFisica.regimeComunhaoBens',
                        type: 'select',
                        rendered:
                          "#{utils.contains('|CASADO|UNIAO_ESTAVEL|',pessoa.pessoaFisica.estadoCivil.constante)}",
                        elRequired: "utils.contains('|CASADO|UNIAO_ESTAVEL|',@this.estadoCivil.constante)",
                        space: 6,

                        required: true,
                        rowEdit: false,
                        title: utils.lng('regime_comunhao_bens','Regime de Comunhão de Bens'),
                        label: utils.lng('regime_comunhao_bens','Regime de Comunhão de Bens'),
                        list: {
                          entity: 'RegimeComunhaoBens',
                          url: 'RegimeComunhaoBens'
                        },
                        /*
                        data: [
                          {
                            label: 'Não se Aplica',
                            value: 'NAO_APLICA',
                            id: 5,
                          },
                          {
                            label: 'Null',
                            value: 'null',
                            id: 8,
                          },
                          {
                            label: 'Comunhão Universal de Bens',
                            value: 'COMUNHAO_UNIVERSAL',
                            id: 1,
                          },
                          {
                            label: 'Comunhão Parcial de Bens',
                            value: 'COMUNHAO_PARCIAL',
                            id: 2,
                          },
                          {
                            label: 'Separação de Bens',
                            value: 'SEPARACAO_TOTAL',
                            id: 3,
                          },
                          {
                            label: 'Participação Final nos Aquetos',
                            value: 'PARTICIPACAO_FINAL',
                            id: 4,
                          },
                        ],
                        */
                        attrs: {
                          owner: 'pessoa.pessoaFisica',
                        },
                      },
                      pessoa_pessoaJuridica_dataFundacao: {
                        edit: true,
                        id: 'pessoa_pessoaJuridica_dataFundacao',
                        entity: 'Date',
                        name: 'dataFundacao',
                        group: 'group_dados',
                        field: 'pessoa.pessoaJuridica.dataFundacao',
                        type: 'datetime',
                        rendered: "#{pessoa.tipo.constante == 'PJ' }",
                        space: 3,

                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('data_fundacao','Data Fundação'),
                        label: utils.lng('data_fundacao','Data Fundação'),
                        attrs: {
                          owner: 'pessoa.pessoaJuridica',
                        },
                      },
                      pessoa_pessoaJuridica_id: {
                        edit: true,
                        id: 'pessoa_pessoaJuridica_id',
                        entity: 'Integer',
                        name: 'id',
                        group: 'group_dados',
                        field: 'pessoa.pessoaJuridica.id',
                        type: 'number',
                        rendered: "#{pessoa.tipo.constante == 'PJ' }",
                        space: 3,
                        visible: false,
                        required: true,
                        rowEdit: false,
                        title: utils.lng('codigo','Código'),
                        label: utils.lng('codigo','Código'),
                        attrs: {
                          owner: 'pessoa.pessoaJuridica',
                        },
                      },
                      pessoa_nomeReduz: {
                        edit: true,
                        id: 'pessoa_nomeReduz',
                        entity: 'String',
                        name: 'nomeReduz',
                        group: 'group_dados',
                        field: 'pessoa.nomeReduz',
                        type: 'text',
                        space: 6,

                        required: true,
                        //rowEdit: false,
                        //elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('nome_fantasia','Nome Fantasia'),
                        label: utils.lng('nome_fantasia','Nome Fantasia'),
                        attrs: {
                          //disabled: true,
                          owner: 'pessoa',
                        },
                      },
                      tipoCliente: {
                        id: 'tipoCliente',
                        //edit: true,
                        //itemValue: 'value',
                        //itemLabel: 'label',
                        entity: 'StatusCliente',
                        name: 'tipoCliente',
                        group: 'group_dados',
                        field: 'tipoCliente',
                        type: 'select',
                        space: 6,

                        rowEdit: false,
                        disabled: true,
                        title: utils.lng('status','Status'),
                        label: utils.lng('status','Status'),
                        list: {
                          entity: 'StatusCliente',
                          url: 'StatusCliente',
                        },
                        /*
                        data: [
                          {
                            label: 'Revisão',
                            value: 'REVISAO',
                            id: 29,
                          },
                          {
                            label: 'Evoluir Para DiEnergy',
                            value: 'EVOLUIR_PARA_DIENERGY',
                            id: 27,
                          },
                          {
                            label: 'Reativação',
                            value: 'REATIVACAO',
                            id: 30,
                          },
                          {
                            label: 'Evoluir de DI Energy para DI Nipponflex',
                            value: 'EVOLUIR_DIENERGY_PARA_DI',
                            id: 31,
                          },
                          {
                            label: 'Rejeitado',
                            value: 'REJEITADO',
                            id: 32,
                          },
                          {
                            label: 'Inativo SEFAZ',
                            value: 'INATIVO_SEFAZ',
                            id: 35,
                          },
                          {
                            label: 'Evoluindo',
                            value: 'EVOLUINDO',
                            id: 22,
                          },
                          {
                            label: 'Evoluir Para DI',
                            value: 'EVOLUIR_PARA_DI',
                            id: 19,
                          },
                          {
                            label: 'Andamento',
                            value: 'ANDAMENTO',
                            id: 1,
                          },
                          {
                            label: 'Em Análise',
                            value: 'EM_ANALISE',
                            id: 2,
                          },
                          {
                            label: 'Reenviado',
                            value: 'REENVIADO',
                            id: 25,
                          },
                          {
                            label: 'Aprovado',
                            value: 'APROVADO',
                            id: 4,
                          },
                          {
                            label: 'Aguardando Assinatura do Diretor',
                            value: 'AGUARDANDO_ASSINATURA_DIRETOR',
                            id: 33,
                          },
                          {
                            label: 'Aguardando Assinatura do Cliente',
                            value: 'AGUARDANDO_ASSINATURA_CLIENTE',
                            id: 34,
                          },
                          {
                            label: 'Finalizado',
                            value: 'FINALIZADO',
                            id: 6,
                          },
                          {
                            label: 'Correções',
                            value: 'CORRECOES',
                            id: 3,
                          },
                          {
                            label: 'Assinatura Inválida',
                            value: 'ASS_INVALIDA',
                            id: 5,
                          },
                          {
                            label: 'Cancelado',
                            value: 'CANCELADO',
                            id: 7,
                          },
                          {
                            label: 'Ativo',
                            value: 'ATIVO',
                            id: 15,
                          },
                          {
                            label: 'Pendente',
                            value: 'PENDENTE',
                            id: 17,
                          },
                          {
                            label: 'Recomendação',
                            value: 'RECOMENDACAO',
                            id: 18,
                          },
                          {
                            label: 'Evoluido',
                            value: 'EVOLUIDO',
                            id: 23,
                          },
                        ],
                        */
                        attrs: {
                          disabled: true,
                          owner: '',
                        },
                      },
                      perfis: {
                        edit: true,
                        id: 'perfis',
                        layout: 'table',
                        styleClass: 'ui-crud-search',
                        entity: 'Perfil',
                        name: 'perfis',
                        group: 'group_dados',
                        field: 'perfis',
                        type: 'list',
                        space: 6,
                        print: true,
                        add: true,

                        filter: false,
                        showLabel: false,
                        rowEdit: false,
                        disabled: true,
                        title: utils.lng('perfil','Perfil'),
                        label: utils.lng('perfil','Perfil'),
                        columns: {
                          id: {
                            styleClass: 'ui-co-col-number',
                            entity: 'Integer',
                            name: 'id',
                            type: 'number',

                            filter: false,
                            sort: true,
                            title: utils.lng('codigo','Código'),
                            label: utils.lng('codigo','Código'),
                          },
                          descricao: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'descricao',
                            type: 'text',

                            sort: true,
                            title: utils.lng('descricao','Descrição'),
                            label: utils.lng('descricao','Descrição'),
                          },
                          ativo: {
                            styleClass: 'ui-co-col-checkbox',
                            entity: 'boolean',
                            name: 'ativo',
                            type: 'checkbox',

                            sort: true,
                            title: utils.lng('ativo','Ativo'),
                            label: utils.lng('ativo','Ativo'),
                            data: [
                              {
                                label: utils.lng('selecione','Selecione'),
                                value: '',
                              },
                              {
                                label: utils.lng('sim','Sim'),
                                value: 'true',
                              },
                              {
                                label: utils.lng('nao','Não'),
                                value: 'false',
                              },
                            ],
                          },
                        },
                        click: {
                          entity: 'Perfil',
                          action: 'rowSelect',
                          alert: false,
                        },
                        list: {
                          entity: 'Perfil',
                          mappedBy: 'parent',
                          field: 'perfis',
                          url: 'Perfil',
                          method: 'GET',
                          lazy: true,
                        },
                        mappedBy: 'parent',
                        attrs: {
                          type: 'entity',
                          disabled: true,
                          owner: '',
                        },
                      },
                    },
                  },
                },
              },
              group_contatos: {
                index: 1,
                id: 'group_contatos',
                layout: 'group',
                name: 'group_contatos',
                type: 'tabItem',
                label: utils.lng('contatos','Contatos'),
                elements: {
                  'session_group_contatos_session_pessoa.telefones': {
                    id: 'session_group_contatos_session_pessoa.telefones',
                    type: 'card',
                    space: 12,
                    label: utils.lng('contatos','Contatos'),
                    elements: {
                      pessoa_telefones: {
                        edit: {
                          element: editPessoaTelefone,
                        },
                        id: 'pessoa_telefones',
                        layout: 'table',
                        styleClass: 'ui-crud-search',
                        entity: 'PessoaTelefone',
                        name: 'telefones',
                        group: 'group_contatos',
                        field: 'pessoa.telefones',
                        type: 'list',
                        space: 12,
                        print: true,
                        add: {
                          element: editPessoaTelefone,
                        },

                        filter: false,
                        showLabel: false,
                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('contatos','Contatos'),
                        label: utils.lng('contatos','Contatos'),
                        columns: {
                          id: {
                            styleClass: 'ui-co-col-number',
                            entity: 'String',
                            name: 'id',
                            type: 'number',

                            filter: false,
                            sort: false,
                            title: 'Código',
                            label: utils.lng('codigo','Código'),
                          },
                          telefone_completo: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'telefone_completo',
                            type: 'text',

                            filter: false,
                            sort: false,
                            title: utils.lng('telefone','Telefone'),
                            label: utils.lng('telefone','Telefone'),
                            expression: '${@this.ddi}${@this.ddd}${@this.telefone}',
                          },
                          tipo: {
                            styleClass: 'ui-co-col-entity',
                            entity: 'String',
                            name: 'tipo',
                            type: 'entity',

                            filter: false,
                            sort: false,
                            title: utils.lng('tipo','Tipo'),
                            label: utils.lng('tipo','Tipo'),
                          },
                          ativo: {
                            styleClass: 'ui-co-col-checkbox',
                            entity: 'String',
                            name: 'ativo',
                            type: 'checkbox',

                            filter: false,
                            sort: false,
                            title: utils.lng('ativo','Ativo'),
                            label: utils.lng('ativo','Ativo'),
                            data: [
                              {
                                label: utils.lng('selecione','Selecione'),
                                value: '',
                              },
                              {
                                label: utils.lng('sim','Sim'),
                                value: 'true',
                              },
                              {
                                label: utils.lng('nao','Não'),
                                value: 'false',
                              },
                            ],
                          },
                        },
                        click: {
                          entity: 'PessoaTelefone',
                          action: 'rowEdit',
                        },
                        list: {
                          entity: 'PessoaTelefone',
                          mappedBy: 'pessoa',
                          field: 'telefones',
                          url: 'PessoaTelefone',
                          method: 'GET',
                          lazy: true,
                        },
                        mappedBy: 'pessoa',
                        attrs: {
                          owner: 'pessoa',
                        },
                      },
                    },
                  },
                  'session_group_contatos_session_pessoa.emails': {
                    id: 'session_group_contatos_session_pessoa.emails',
                    type: 'card',
                    space: 12,
                    label: utils.lng('emails','Emails'),
                    elements: {
                      pessoa_emails: {
                        edit: {
                          element: editPessoaEmail,
                        },
                        id: 'pessoa_emails',
                        layout: 'table',
                        styleClass: 'ui-crud-search',
                        entity: 'PessoaEmail',
                        name: 'emails',
                        group: 'group_contatos',
                        field: 'pessoa.emails',
                        type: 'list',
                        space: 12,
                        print: true,
                        add: {
                          element: editPessoaEmail,
                        },

                        filter: false,
                        showLabel: false,
                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('emails','Emails'),
                        label: utils.lng('emails','Emails'),
                        columns: {
                          id: {
                            styleClass: 'ui-co-col-number',
                            entity: 'Integer',
                            name: 'id',
                            type: 'number',

                            filter: false,
                            sort: true,
                            title: utils.lng('codigo','Código'),
                            label: utils.lng('codigo','Código'),
                          },
                          ativo: {
                            styleClass: 'ui-co-col-checkbox',
                            entity: 'boolean',
                            name: 'ativo',
                            type: 'checkbox',

                            sort: true,
                            title: utils.lng('ativo','Ativo'),
                            label: utils.lng('ativo','Ativo'),
                            data: [
                              {
                                label: utils.lng('selecione','Selecione'),
                                value: '',
                              },
                              {
                                label: utils.lng('sim','Sim'),
                                value: 'true',
                              },
                              {
                                label: utils.lng('nao','Não'),
                                value: 'false',
                              },
                            ],
                          },
                          tipo: {
                            styleClass: 'ui-co-col-select',
                            entity: 'EnumTipoEmail',
                            name: 'tipo',
                            type: 'select',

                            sort: true,
                            title: utils.lng('tipo','Tipo'),
                            label: utils.lng('tipo','Tipo'),
                            data: [
                              {
                                label: utils.lng('selecione','Selecione'),
                                value: '',
                              },
                              {
                                label: utils.lng('principal','Principal'),
                                value: 'PRINCIPAL',
                              },
                              {
                                label: utils.lng('compras','Compras'),
                                value: 'COMPRAS',
                              },
                              {
                                label: utils.lng('vendas','Vendas'),
                                value: 'VENDAS',
                              },
                              {
                                label: utils.lng('financeiro','Financeiro'),
                                value: 'FINANCEIRO',
                              },
                              {
                                label: utils.lng('contato','Contato'),
                                value: 'CONTATO',
                              },
                            ],
                          },
                          email: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'email',
                            type: 'text',

                            sort: true,
                            title: utils.lng('email','Email'),
                            label: utils.lng('email','Email'),
                          },
                        },
                        click: {
                          entity: 'PessoaEmail',
                          action: 'rowEdit',
                        },
                        list: {
                          entity: 'PessoaEmail',
                          mappedBy: 'pessoa',
                          field: 'emails',
                          url: 'PessoaEmail',
                          method: 'GET',
                          lazy: true,
                        },
                        mappedBy: 'pessoa',
                        attrs: {
                          owner: 'pessoa',
                        },
                      },
                    },
                  },
                },
              },
              group_enderecos: {
                index: 2,
                id: 'group_enderecos',
                layout: 'group',
                name: 'group_enderecos',
                type: 'tabItem',
                label: utils.lng('enderecos','Endereços'),
                elements: {
                  'session_group_enderecos_session_pessoa.enderecos': {
                    id: 'session_group_enderecos_session_pessoa.enderecos',
                    type: 'card',
                    space: 12,
                    label: utils.lng('enderecos','Endereços'),
                    elements: {
                      pessoa_enderecos: {
                        edit: {
                          element: editEndereco,
                        },
                        id: 'pessoa_enderecos',
                        layout: 'table',
                        styleClass: 'ui-crud-search',
                        entity: 'PessoaEndereco',
                        name: 'enderecos',
                        group: 'group_enderecos',
                        field: 'pessoa.enderecos',
                        type: 'list',
                        space: 12,
                        print: true,
                        add: {
                          element: editEndereco,
                        },

                        filter: false,
                        showLabel: false,
                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('enderecos','Endereços'),
                        label: utils.lng('enderecos','Endereços'),
                        columns: {
                          cep: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'cep',
                            type: 'text',

                            sort: true,
                            title: utils.lng('cep','CEP'),
                            label: utils.lng('cep','CEP'),
                          },
                          id: {
                            styleClass: 'ui-co-col-number',
                            entity: 'Integer',
                            name: 'id',
                            type: 'number',

                            filter: false,
                            sort: true,
                            title: utils.lng('codigo','Código'),
                            label: utils.lng('codigo','Código'),
                          },
                          bairro: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'bairro',
                            type: 'text',

                            sort: true,
                            title: utils.lng('bairro','Bairro'),
                            label: utils.lng('bairro','Bairro'),
                          },
                          logradouro: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'logradouro',
                            type: 'text',

                            sort: true,
                            title: utils.lng('logradouro','Logradouro'),
                            label: utils.lng('logradouro','Logradouro'),
                          },
                          numero: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'numero',
                            type: 'text',

                            sort: true,
                            title: utils.lng('numero','Numero'),
                            label: utils.lng('numero','Numero'),
                          },
                          cidade: {
                            styleClass: 'ui-co-col-entity',
                            entity: 'Cidade',
                            name: 'cidade',
                            type: 'entity',

                            sort: true,
                            title: utils.lng('cidade','Cidade'),
                            label: utils.lng('cidade','Cidade'),
                          },
                          cidade_superior: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'cidade_superior',
                            type: 'text',

                            sort: true,
                            title: utils.lng('distrito','Distrito'),
                            label: utils.lng('distrito','Distrito'),
                          },
                          tipo: {
                            styleClass: 'ui-co-col-select',
                            entity: 'TipoEndereco',
                            name: 'tipo',
                            type: 'select',

                            sort: true,
                            title: utils.lng('tipo','Tipo'),
                            label: utils.lng('tipo','Tipo'),
                            list: {
                              entity: 'TipoEndereco',
                              url: 'TipoEndereco'
                            },
                            /*
                            data: [
                              {
                                label: 'Profissional',
                                value: 'PROFISSIONAL',
                              },
                              {
                                label: 'Comercial',
                                value: 'COMERCIAL',
                              },
                              {
                                label: 'Residencial',
                                value: 'RESIDENCIAL',
                              },
                              {
                                label: 'Entrega',
                                value: 'ENTREGA',
                              },
                            ],
                            */
                          },
                          ativo: {
                            styleClass: 'ui-co-col-checkbox',
                            entity: 'boolean',
                            name: 'ativo',
                            type: 'checkbox',

                            sort: true,
                            title: utils.lng('ativo','Ativo'),
                            label: utils.lng('ativo','Ativo'),
                            data: [
                              {
                                label: utils.lng('selecione','Selecione'),
                                value: '',
                              },
                              {
                                label: utils.lng('sim','Sim'),
                                value: 'true',
                              },
                              {
                                label: utils.lng('nao','Não'),
                                value: 'false',
                              },
                            ],
                          },
                          pais: {
                            styleClass: 'ui-co-col-text',
                            entity: 'Pais',
                            name: 'pais',
                            type: 'text',

                            sort: true,
                            title: utils.lng('pais','País'),
                            label: utils.lng('pais','País'),
                          },
                        },
                        click: {
                          entity: 'PessoaEndereco',
                          action: 'rowEdit',
                        },
                        list: {
                          entity: 'PessoaEndereco',
                          mappedBy: 'pessoa',
                          field: 'enderecos',
                          url: 'PessoaEndereco',
                          method: 'GET',
                          lazy: true,
                        },
                        mappedBy: 'pessoa',
                        attrs: {
                          owner: 'pessoa',
                        },
                      },
                    },
                  },
                },
              },
              group_contas: {
                index: 3,
                id: 'group_contas',
                layout: 'group',
                name: 'group_contas',
                type: 'tabItem',
                label: utils.lng('dados_bancarios','Dados Bancários'),
                elements: {
                  'session_group_contas_session_pessoa.dadosBancarios': {
                    id: 'session_group_contas_session_pessoa.dadosBancarios',
                    type: 'card',
                    space: 12,
                    label: utils.lng('dados_bancarios','Dados Bancários'),
                    elements: {
                      pessoa_dadosBancarios: {
                        edit: {
                          element: editPessoaDadosBancarios,
                        },
                        layout: 'table',
                        styleClass: 'ui-crud-search',
                        entity: 'PessoaDadosBancarios',
                        name: 'dadosBancarios',
                        group: 'group_contas',
                        field: 'pessoa.dadosBancarios',
                        type: 'list',
                        space: 12,
                        print: true,
                        add: {
                          element: editPessoaDadosBancarios,
                        },

                        filter: false,
                        showLabel: false,
                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: 'Dados Bancários',
                        label: utils.lng('dados_bancarios','Dados Bancários'),
                        columns: {
                          dhRegistro: {
                            styleClass: 'ui-co-col-datetime',
                            entity: 'Date',
                            name: 'dhRegistro',
                            type: 'datetime',

                            sort: true,
                            range: true,
                            title: 'Data Registro',
                            label: utils.lng('data_registro','Data Registro'),
                          },
                          id: {
                            styleClass: 'ui-co-col-number',
                            entity: 'Integer',
                            name: 'id',
                            type: 'number',

                            filter: false,
                            sort: true,
                            title: utils.lng('codigo','Código'),
                            label: utils.lng('codigo','Código'),
                          },
                          banco: {
                            styleClass: 'ui-co-col-entity',
                            entity: 'Banco',
                            name: 'banco',
                            type: 'entity',

                            sort: true,
                            title: utils.lng('banco','Banco'),
                            label: utils.lng('banco','Banco'),
                          },
                          conta: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'conta',
                            type: 'text',

                            sort: true,
                            title: utils.lng('conta','Conta'),
                            label: utils.lng('conta','Conta'),
                          },
                          nome: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'nome',
                            type: 'text',

                            sort: true,
                            title: utils.lng('razao_social','Razão Social'),
                            label: utils.lng('razao_social','Razão Social'),
                          },
                        },
                        click: {
                          entity: 'PessoaDadosBancarios',
                          action: 'rowEdit',
                        },
                        list: {
                          entity: 'PessoaDadosBancarios',
                          mappedBy: 'pessoa',
                          field: 'dadosBancarios',
                          url: 'PessoaDadosBancarios',
                          method: 'GET',
                          lazy: true,
                        },
                        mappedBy: 'pessoa',
                        attrs: {
                          owner: 'pessoa',
                        },
                      },
                    },
                  },
                },
              },
              group_documentos: {
                index: 4,
                id: 'group_documentos',
                layout: 'group',
                name: 'group_documentos',
                type: 'tabItem',
                label: utils.lng('documentos','Documentos'),
                elements: {
                  'session_group_documentos_session_pessoa.documentos': {
                    id: 'session_group_documentos_session_pessoa.documentos',
                    type: 'card',
                    space: 12,
                    label: utils.lng('documentos','Documentos'),
                    elements: {
                      pessoa_documentos: {
                        edit: {
                          element: editPessoaDocumento,
                        },
                        id: 'pessoa_documentos',
                        layout: 'table',
                        styleClass: 'ui-crud-search',
                        entity: 'PessoaDocumento',
                        name: 'documentos',
                        group: 'group_documentos',
                        field: 'pessoa.documentos',
                        type: 'list',
                        space: 12,
                        print: true,
                        add: {
                          element: editPessoaDocumento,
                        },

                        filter: false,
                        showLabel: false,
                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('documentos','Documentos'),
                        label: utils.lng('documentos','Documentos'),
                        columns: {
                          dhRegistro: {
                            styleClass: 'ui-co-col-datetime',
                            entity: 'String',
                            name: 'dhRegistro',
                            type: 'datetime',

                            sort: true,
                            range: true,
                            title: utils.lng('data_registro','Data registro'),
                            label: utils.lng('data_registro','Data registro'),
                          },
                          id: {
                            styleClass: 'ui-co-col-number',
                            entity: 'Integer',
                            name: 'id',
                            type: 'number',

                            filter: false,
                            sort: true,
                            title: utils.lng('codigo','Código'),
                            label: utils.lng('codigo','Código'),
                          },
                          tipo: {
                            styleClass: 'ui-co-col-select',
                            entity: 'TipoDocumentoPessoa',
                            name: 'tipo',
                            type: 'select',

                            sort: true,
                            title: utils.lng('tipo','Tipo'),
                            label: utils.lng('tipo','Tipo'),
                            list: {
                              entity: 'TipoDocumentoPessoa',
                              url: 'TipoDocumentoPessoa'
                            },
                            /*
                            data: [
                              {
                                label: 'Foto para reconocimientos *',
                                value: 'FOTO_REC_PAR',
                              },
                              {
                                label: 'RUC Actualizado *',
                                value: 'RUC_ACTUALIZADO_ECU',
                              },
                              {
                                label: 'Fotografia del nuevo DI *',
                                value: 'FOTO_DI_ECU',
                              },
                              {
                                label: 'Foto para reconocimientos *',
                                value: 'FOTO_REC_MEX',
                              },
                              {
                                label: 'Foto para reconocimientos *',
                                value: 'FOTO_REC_COL',
                              },
                              {
                                label: 'Foto para reconocimientos *',
                                value: 'FOTO_REC_ECU',
                              },
                              {
                                label: 'Fotocopia de Cédula de Identidad del titular *',
                                value: 'CEDULA_PAR',
                              },
                              {
                                label: 'Ficha de entrevista con el Graduado *',
                                value: 'FICHA_ENTREV_PAR',
                              },
                              {
                                label: 'Formulario de registro del monitor *',
                                value: 'FICHA_MONITOR_PAR',
                              },
                              {
                                label: 'Comprobante de Domicilio *',
                                value: 'COMP_END_PAR',
                              },
                              {
                                label: 'Fotocopia de INE (identificación) del titular *',
                                value: 'FTC_MEX',
                              },
                              {
                                label: 'Fotocopia de INE del cónyuge',
                                value: 'INE_CONJ_MEX',
                              },
                              {
                                label: 'Contrato de prestación de servicios *',
                                value: 'CONTRATO_SPV_PAR',
                              },
                              {
                                label: 'Contrato de Distribuidor Independiente *',
                                value: 'CONTRATO_DI_PAR',
                              },
                              {
                                label: 'Carteira de Trabalho e Previdência Social',
                                value: 'CTPS',
                              },
                              {
                                label: 'Identidade de Classe',
                                value: 'IC',
                              },
                              {
                                label: 'Comprovante de Endereço - Residêncial*',
                                value: 'CE',
                              },
                              {
                                label: 'Passaporte',
                                value: 'PASS',
                              },
                              {
                                label: 'Procuração',
                                value: 'PROC',
                              },
                              {
                                label: 'Fotocopia de Cédula de Identidad del cónyuge',
                                value: 'FTC_CIC_ECU',
                              },
                              {
                                label: 'Fotocopia de Cédula de Identidad del representante legal (si no es el titular)',
                                value: 'FTC_CIR_ECU',
                              },
                              {
                                label: 'Fotocopia de Cédula de Identidad del cónyuge',
                                value: 'FTC_ID_CON_PAR',
                              },
                              {
                                label: 'Documento Cônjuge (CNG, CPF ou RG)',
                                value: 'DOC_CONJ',
                              },
                              {
                                label: 'RG (FRENTE)',
                                value: 'RG_FRENTE',
                              },
                              {
                                label: 'RG (VERSO)',
                                value: 'RG_VERSO',
                              },
                              {
                                label: 'Comprovante de Conta Bancária',
                                value: 'CONTA',
                              },
                              {
                                label: 'Comprovante de endereço*',
                                value: 'ENDERECO',
                              },
                              {
                                label: 'Comprovante de Estado Civil*',
                                value: 'CNC',
                              },
                              {
                                label: 'RG*',
                                value: 'RG',
                              },
                              {
                                label: 'CPF*',
                                value: 'CPF',
                              },
                              {
                                label: 'CNH*',
                                value: 'CNH',
                              },
                              {
                                label: 'Cópia do documento de identificação (cédula ou passaporte)*',
                                value: 'DI',
                              },
                              {
                                label: 'Foto atualizada*',
                                value: 'FOTO',
                              },
                              {
                                label: 'Fotocopia de INE del representante legal (si no es o titular)',
                                value: 'FTC_INR_MEX',
                              },
                              {
                                label: 'Fotocopia de Cédula de Identidad del titular *',
                                value: 'FTC_CIT_ECU',
                              },
                              {
                                label: 'Fotocopia de servicio básico (luz, agua, internet, etc.) *',
                                value: 'FTC_SER_ECU',
                              },
                              {
                                label: 'Comprobante de domicilio (CFE) *',
                                value: 'COM_DOM_MEX',
                              },
                              {
                                label: 'Poder del representante administrador *',
                                value: 'POD_ADM_MEX',
                              },
                              {
                                label: 'Documento de identidad / Cédula del representante legal',
                                value: 'CED_REP_COL',
                              },
                              {
                                label: 'Fotocopia de Cédula de Ciudadanía del titular *',
                                value: 'CED_CIU_COL',
                              },
                              {
                                label: 'Comprobante de residencia *',
                                value: 'COM_RES_COL',
                              },
                              {
                                label: 'Fotocopia de Cédula de Identidad del representante legal (si no es el titular)',
                                value: 'FTC_ID_RPE_PAR',
                              },
                              {
                                label: 'Fotocopia de servicio básico (luz, agua, internet, etc.) *',
                                value: 'FTC_SER_BAS_PAR',
                              },
                            ],
                            */
                          },
                          url: {
                            styleClass: 'ui-co-col-upload',
                            entity: 'String',
                            name: 'url',
                            type: 'upload',

                            filter: false,
                            sort: false,
                            title: utils.lng('comprovante','Comprovante'),
                            label: utils.lng('comprovante','Comprovante'),
                            attrs: {
                              googlePreview: false,
                            },
                          },
                        },
                        click: {
                          entity: 'PessoaDocumento',
                          action: 'rowEdit',
                        },
                        list: {
                          entity: 'PessoaDocumento',
                          mappedBy: 'pessoa',
                          field: 'documentos',
                          url: 'PessoaDocumento',
                          method: 'GET',
                          lazy: true,
                        },
                        mappedBy: 'pessoa',
                        attrs: {
                          owner: 'pessoa',
                        },
                      },
                    },
                  },
                  'session_group_documentos_session_pessoa.arquivos': {
                    id: 'session_group_documentos_session_pessoa.arquivos',
                    type: 'card',
                    space: 12,
                    label: utils.lng('outros_arquivos','Outros arquivos e  documentos'),
                    elements: {
                      pessoa_arquivos: {
                        edit: {
                          element: editDocumento,
                        },
                        id: 'pessoa_arquivos',
                        layout: 'table',
                        styleClass: 'ui-crud-search',
                        entity: 'Documento',
                        name: 'arquivos',
                        group: 'group_documentos',
                        field: 'pessoa.arquivos',
                        type: 'list',
                        space: -1,
                        print: true,
                        add: {
                          element: editDocumento,
                        },

                        filter: false,
                        showLabel: false,
                        rowEdit: false,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('outros_arquivos','Outros arquivos e  documentos'),
                        label: utils.lng('outros_arquivos','Outros arquivos e  documentos'),
                        columns: {
                          dhRegistro: {
                            styleClass: 'ui-co-col-datetime',
                            entity: 'Date',
                            name: 'dhRegistro',
                            type: 'datetime',

                            sort: true,
                            range: true,
                            title: utils.lng('data_registro','Data registro'),
                            label: utils.lng('data_registro','Data registro'),
                          },
                          id: {
                            styleClass: 'ui-co-col-number',
                            entity: 'Integer',
                            name: 'id',
                            type: 'number',

                            filter: false,
                            sort: true,
                            title: utils.lng('codigo','Código'),
                            label: utils.lng('codigo','Código'),
                          },
                          tipoDocumento: {
                            styleClass: 'ui-co-col-select',
                            itemValue: 'id',
                            entity: 'TipoDocumento',
                            name: 'tipoDocumento',
                            type: 'select',

                            sort: true,
                            title: utils.lng('tipo','Tipo'),
                            label: utils.lng('tipo','Tipo'),
                            list: {
                              url: 'TipoDocumento',
                            },
                          },
                          caminho: {
                            styleClass: 'ui-co-col-upload',
                            entity: 'String',
                            name: 'caminho',
                            type: 'upload',

                            sort: true,
                            title: utils.lng('caminho','Caminho'),
                            label: utils.lng('caminho','Caminho'),
                            attrs: {
                              googlePreview: false,
                            },
                          },
                          nome: {
                            styleClass: 'ui-co-col-text',
                            entity: 'String',
                            name: 'nome',
                            type: 'text',

                            sort: true,
                            title: utils.lng('nome','Nome'),
                            label: utils.lng('nome','Nome'),
                          },
                        },
                        click: {
                          entity: 'Documento',
                          action: 'rowEdit',
                        },
                        list: {
                          entity: 'Documento',
                          mappedBy: 'idEntidade',
                          field: 'arquivos',
                          url: 'Documento',
                          method: 'GET',
                          lazy: true,
                        },
                        mappedBy: 'idEntidade',
                        attrs: {
                          entity: 'Documento',
                          type: 'list',
                          params: {
                            entidade: 'Pessoa',
                            id_entidade: '${@this.pessoa.id}',
                          },
                          owner: 'pessoa',
                        },
                      },
                    },
                  },
                },
              },
              group_socios: {
                index: 5,
                id: 'group_socios',
                layout: 'group',
                name: 'group_socios',
                type: 'tabItem',
                label: utils.lng('socios','Socios'),
                elements: {
                  'session_group_socios_session_pessoa.socios': {
                    id: 'session_group_socios_session_pessoa.socios',
                    type: 'card',
                    space: 12,
                    label: utils.lng('socios','Socios'),
                    elements: {
                      pessoa_socios: {
                        edit: {
                          element: editPessoaSocio,
                        },
                        id: 'pessoa_socios',
                        layout: 'table',
                        styleClass: 'ui-crud-search',
                        entity: 'PessoaSocio',
                        name: 'socios',
                        group: 'group_socios',
                        field: 'pessoa.socios',
                        type: 'list',
                        space: 12,
                        print: true,
                        add: false,

                        filter: false,
                        showLabel: false,
                        rowEdit: true,
                        elEdit: "${user.status_penn !== 'INATIVO'}",
                        title: utils.lng('socios','Socios'),
                        label: utils.lng('socios','Socios'),
                        columns: {
                          id: {
                            styleClass: 'ui-co-col-number',
                            entity: 'Integer',
                            name: 'id',
                            type: 'number',

                            filter: false,
                            sort: true,
                            title: utils.lng('codigo','Código'),
                            label: utils.lng('codigo','Código'),
                          },
                          tipoSocio: {
                            styleClass: 'ui-co-col-select',
                            entity: 'TipoSocio',
                            name: 'tipoSocio',
                            type: 'select',

                            sort: true,
                            title: utils.lng('tipo_socio','Tipo Socio'),
                            label: utils.lng('tipo_socio','Tipo Socio'),
                            disabled: true,
                            list: {
                              entity: 'TipoSocio',
                              url: 'TipoSocio'
                            },
                            /*
                            data: [
                              {
                                label: 'Sócio Administrador',
                                value: 'SOCIO_ADMINISTRADOR',
                              },
                              {
                                label: 'Sócio Cotista',
                                value: 'SOCIO_COTISTA',
                              },
                              {
                                label: 'Administrador não Sócio',
                                value: 'ADMINISTRADOR_NAO_SOCIO',
                              },
                              {
                                label: 'Procurador Administrador',
                                value: 'PROCURADOR_ADMINISTRADOR',
                              },
                            ],
                            */
                          },
                          socio: {
                            styleClass: 'ui-co-col-entity',
                            entity: 'Pessoa',
                            name: 'socio',
                            type: 'entity',

                            sort: true,
                            title: utils.lng('socio','Socio'),
                            label: utils.lng('socio','Socio'),
                          },
                          qualificado: {
                            styleClass: 'ui-co-col-checkbox',
                            entity: 'boolean',
                            name: 'qualificado',
                            type: 'checkbox',

                            disabled: true,
                            sort: true,
                            title: utils.lng('qualificado','Qualificado'),
                            label: utils.lng('qualificado','Qualificado'),
                            data: [
                              {
                                label: utils.lng('selecione','Selecione'),
                                value: '',
                              },
                              {
                                label: utils.lng('sim','Sim'),
                                value: 'true',
                              },
                              {
                                label: utils.lng('nao','Não'),
                                value: 'false',
                              },
                            ],
                          },
                        },
                        click: {
                          entity: 'PessoaSocio',
                          action: 'rowEdit',
                        },
                        list: {
                          entity: 'PessoaSocio',
                          mappedBy: 'pessoa',
                          field: 'socios',
                          url: 'PessoaSocio',
                          method: 'GET',
                          lazy: true,
                        },
                        mappedBy: 'pessoa',
                        attrs: {
                          owner: 'pessoa',
                        },
                      },
                    },
                  },
                },
              },
              buttons: {
                edit: true,
                id: 'buttons',
                layout: 'buttons',
                type: 'group',
                elEdit: '${true}',
                elements: {
                  buttons_left: {
                    id: 'buttons_left',
                    styleClass: 'ui-buttons-left',
                    elements: {
                      close: {
                        edit: true,
                        id: 'close',
                        theme: 'default',
                        name: 'close',
                        type: 'button',
                        elEdit: '${true}',
                        label: utils.lng('fechar','Fechar'),
                        click: {
                          entity: 'Usuario',
                          action: 'close',
                          back: false,
                          reload: [],
                        },
                      },
                    },
                  },
                  buttons_right: {
                    id: 'buttons_right',
                    styleClass: 'ui-buttons-right',
                    elements: {
                      remove: {
                        id: 'remove',
                        theme: 'secondary',
                        name: 'remove',
                        type: 'button',
                        rendered: '${crud.selected.id > 0}',
                        visible: false,
                        label: utils.lng('remover','Remover'),
                        click: {
                          entity: 'Usuario',
                          prompt: 'Tem certeza que deseja excluir?',
                          url: 'Usuario/{id}',
                          method: 'DELETE',
                          back: true,
                          reload: [],
                        },
                      },
                      confirm: {
                        id: 'confirm',
                        theme: 'primary',
                        name: 'confirm',
                        type: 'button',
                        rendered: '${crud.selected.id <= 0 && crud.new}',
                        label: utils.lng('confirmar','Confirmar'),
                        click: {
                          entity: 'Usuario',
                          action: 'confirm',
                          validate: true,
                          back: true,
                          reload: [],
                        },
                      },
                      create: {
                        id: 'create',
                        theme: 'primary',
                        name: 'create',
                        type: 'button',
                        rendered: '${crud.selected.id == 0 && !crud.new}',
                        label: utils.lng('salvar','Salvar'),
                        click: {
                          entity: 'Usuario',
                          url: 'Usuario',
                          method: 'POST',
                          back: true,
                          reload: [],
                        },
                      },
                      print: {
                        id: 'print',
                        label: utils.lng('imprimir','Imprimir'),
                        attrs: {
                          label: "${utils.lng('print','Imprimir')}",
                          type: 'button',
                          click: {
                            url: 'Cliente/print/${@this.id_cliente}.pdf',
                            fileName: 'ficha.pdf',
                            download: true,
                          },
                        },
                      },
                      update: {
                        id: 'update',
                        theme: 'primary',
                        name: 'update',
                        type: 'button',
                        rendered: '${crud.selected.id > 0}',
                        label: utils.lng('salvar','Salvar'),
                        click: {
                          entity: 'Usuario',
                          url: 'salvar/meus_dados/{id}',
                          //url: 'Usuario/{id}',
                          method: 'PUT',
                          back: true,
                          reload: [],
                        },
                      },
                      reativar: {
                        id: 'reativar',
                        label: utils.lng('solicitar_reativacao','Solicitar Reativação'),
                        attrs: {
                          label: "${utils.lng('solicitar_reativacao','Solicitar Reativação')}",
                          type: 'button',
                          rendered: "${user.status_penn === 'INATIVO'}",
                          click: {
                            url: 'Cliente/${@this.id_cliente}',
                            method: 'PUT',
                            redirect: '/home',
                            send: {
                              status: 'REATIVACAO',
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      list: {
        id: 'list',
        rendered: '${!crud.edit}',
        elements: {
          list_data: {
            id: 'list_data',
            layout: 'group',
            styleClass: 'ui-crud-search',
            type: 'list',
            space: 12,
            add: true,
            main: true,
            label: utils.lng('usuario','Usuario'),
            filters: {
              codigo: {
                entity: 'String',
                name: 'codigo',
                field: 'codigo',
                type: 'number',
                filter: 'codigo',
                sort: true,
                title: utils.lng('codigo_mundial','Cód. Mundial'),
                label: utils.lng('codigo_mundial','Cód. Mundial'),
              },
              nome: {
                entity: 'String',
                name: 'nome',
                field: 'nome',
                type: 'text',
                filter: 'nome',
                sort: true,
                title: utils.lng('nome','Nome'),
                label: utils.lng('nome','Nome'),
              },
              perfil: {
                entity: 'String',
                name: 'perfil',
                field: 'perfil',
                type: 'text',
                filter: 'perfil',
                sort: true,
                title: utils.lng('perfil','Perfil'),
                label: utils.lng('perfil','Perfil'),
              },
              email: {
                entity: 'String',
                name: 'email',
                field: 'email',
                type: 'text',
                filter: 'email',
                sort: true,
                title: utils.lng('email','Email'),
                label: utils.lng('email','Email'),
              },
            },
            columns: {
              codigo: {
                styleClass: 'ui-co-col-number',
                entity: 'String',
                name: 'codigo',
                type: 'number',

                sort: true,
                title: utils.lng('codigo_mundial','Cód. Mundial'),
                label: utils.lng('codigo_mundial','Cód. Mundial'),
              },
              nome: {
                styleClass: 'ui-co-col-text',
                entity: 'String',
                name: 'nome',
                type: 'text',

                sort: true,
                title: utils.lng('nome','Nome'),
                label: utils.lng('nome','Nome'),
              },
              perfil: {
                styleClass: 'ui-co-col-text',
                entity: 'String',
                name: 'perfil',
                type: 'text',

                sort: true,
                title: utils.lng('perfil','Perfil'),
                label: utils.lng('perfil','Perfil'),
              },
              email: {
                styleClass: 'ui-co-col-text',
                entity: 'String',
                name: 'email',
                type: 'text',

                sort: true,
                title: utils.lng('email','Email'),
                label: utils.lng('email','Email'),
              },
            },
            click: {
              entity: 'Usuario',
              action: 'open',
              lazy: true,
            },
            list: {
              entity: 'Usuario',
              url: 'Usuario',
              method: 'GET',
              lazy: true,
            },
          },
          buttons: {
            id: 'buttons',
            layout: 'buttons',
            type: 'group',
            elements: {
              buttons_left: {
                id: 'buttons_left',
                styleClass: 'ui-buttons-left',
                elements: {
                  close: {
                    edit: true,
                    id: 'close',
                    theme: 'default',
                    name: 'close',
                    type: 'button',
                    label: utils.lng('fechar','Fechar'),
                    click: {
                      entity: 'Usuario',
                      action: 'close',
                      back: false,
                      reload: [],
                    },
                  },
                  sync: {
                    id: 'sync',
                    theme: 'default',
                    name: 'sync',
                    type: 'button',
                    label: utils.lng('sync','Sync'),
                    click: {
                      entity: 'Usuario',
                      prompt: 'Tem certeza que deseja sincronizar o crud?',
                      url: 'crud/Usuario/refresh',
                      method: 'GET',
                      back: true,
                      reload: [],
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  };

  crud.refresh = function () { };

  useEffect(() => {
    if (!ready) {
      setReady(true);

      utils.execute(crud, 'listarTimelineUsuario', null, function (res) {
        setEventos(res.data);
      });
    }
  });

  return (
    <View>
      <div className="ui-meus-dados-area ui-grid ui-card">
        <div className="ui-col ui-col-6">
          <Crud value={usuario} data={data}></Crud>
        </div>
        <div className="ui-col ui-col-6">
          <div className="ui-title ui-card-timeline-title">
            <b>{utils.lng('timeline_graduacao', 'Timeline de graduação')}</b>
          </div>
          <div className="ui-card-data">
            <div className="gr-timeline">
              {eventos.map((e, i) => (
                <div key={'evt-' + i} className={'gr-timeline-item gr-timeline-item-' + i}>
                  <div className="gr-timeline-date">{e.data_aprovacao}</div>
                  <div className="gr-timeline-avatar">
                    <div className="gr-timeline-avatar-risco"></div>
                    <div className="gr-timeline-avatar-inner" style={{ background: e.cor ? e.cor : '#D2B134' }}>
                      <img src={e.imagem_graduacao}></img>
                    </div>
                  </div>
                  <div className="gr-timeline-label">
                    <span className="gr-timeline-label-inner" style={{ background: e.cor ? e.cor : '#D2B134' }}>
                      {e.descricao}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </View>
  );
}

export default MeusDadosRepresamentoAlteracao;
